// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Uuid from "uuid";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Request from "../../core/Request.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as NextPage from "../../resources/layout-and-structure/NextPage.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as Auth__Types from "../../bundles/Auth/Auth__Types.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Client from "@apollo/client";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as CompanyComboBoxField from "../../modules/CompanyComboBoxField.res.js";
import * as CustomerLocationTile from "../../modules/Customer/CustomerLocationTile.res.js";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";
import * as CustomerAddressEditModal from "../../modules/Customer/CustomerAddressEditModal.res.js";
import * as CustomerCompanySuggestion from "../../modules/Customer/CustomerCompanySuggestion.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";
function customerId(mode) {
  if (typeof mode !== "object") {
    return;
  } else {
    return mode.id;
  }
}
let CustomerFormMode = {
  customerId: customerId
};
function fromFormMode(mode) {
  let rest = {
    information: true,
    addresses: true,
    misc: true
  };
  if (typeof mode !== "object") {
    return rest;
  }
  let match = mode.section;
  if (match === undefined) {
    return rest;
  }
  switch (match) {
    case "Information":
      return {
        information: true,
        addresses: false,
        misc: false
      };
    case "Addresses":
      return {
        information: false,
        addresses: true,
        misc: false
      };
    case "Misc":
      return {
        information: false,
        addresses: false,
        misc: true
      };
  }
}
let CustomerFormFieldsets = {
  fromFormMode: fromFormMode
};
let values = ["France", "Belgium", "Other"];
function key(value) {
  switch (value) {
    case "France":
      return "france";
    case "Belgium":
      return "belgium";
    case "Other":
      return "other";
  }
}
function toLabel(value) {
  switch (value) {
    case "France":
      return I18n.t("France");
    case "Belgium":
      return I18n.t("Belgium");
    case "Other":
      return I18n.t("Other");
  }
}
function fromCountryCode(code) {
  if (typeof code === "object") {
    return;
  }
  switch (code) {
    case "FR":
      return "France";
    case "BE":
      return "Belgium";
    case "LU":
      return "Other";
  }
}
function fromCountry(country) {
  return fromCountryCode(CountryCode.parseIso3166Alpha2(country));
}
let CustomerFormBillingCountry = {
  values: values,
  key: key,
  toLabel: toLabel,
  fromCountryCode: fromCountryCode,
  fromCountry: fromCountry
};
let Raw = {};
let query = Client.gql(["fragment CustomerFormFragment on Customer   {\n__typename  \nid  \nupdatedAt  \nkind  \nshop  {\n__typename  \nid  \n}\n\ncompanyName  \nsiret  \nintraCommunityVAT  \ninvoicingEndpointId  \ninvoicingEndpointIdSchemeCode  \ninvoicingEndpointIdSchemeType  \nfirstName  \nlastName  \ndateOfBirth  \nemail  \nphoneNumber  \nmobileNumber  \nprice  {\n__typename  \nid  \nname  \ntaxIncluded  \n}\n\nlocations  {\n__typename  \nid  \narchivedAt  \nlabel  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \ndefaults  \n}\n\ninternalCode  \nnote  \n}\n"]);
function parse(value) {
  let value$1 = value.kind;
  let tmp;
  switch (value$1) {
    case "BUSINESS":
      tmp = "BUSINESS";
      break;
    case "CONSUMER":
      tmp = "CONSUMER";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$2 = value.shop;
  let value$3 = value.companyName;
  let value$4 = value.siret;
  let value$5 = value.intraCommunityVAT;
  let value$6 = value.invoicingEndpointId;
  let value$7 = value.invoicingEndpointIdSchemeCode;
  let value$8 = value.invoicingEndpointIdSchemeType;
  let tmp$1;
  if (value$8 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$8) {
      case "BE_BCE":
        tmp$2 = "BE_BCE";
        break;
      case "BE_TVA":
        tmp$2 = "BE_TVA";
        break;
      case "FR_SIREN":
        tmp$2 = "FR_SIREN";
        break;
      case "FR_SIREN_SIRET":
        tmp$2 = "FR_SIREN_SIRET";
        break;
      case "FR_SIREN_SIRET_CODEROUTAGE":
        tmp$2 = "FR_SIREN_SIRET_CODEROUTAGE";
        break;
      case "FR_SIREN_SUFFIX":
        tmp$2 = "FR_SIREN_SUFFIX";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$1 = tmp$2;
  }
  let value$9 = value.firstName;
  let value$10 = value.lastName;
  let value$11 = value.dateOfBirth;
  let value$12 = value.email;
  let value$13 = value.phoneNumber;
  let value$14 = value.mobileNumber;
  let value$15 = value.price;
  let value$16 = value.locations;
  let value$17 = value.internalCode;
  let value$18 = value.note;
  return {
    __typename: value.__typename,
    id: value.id,
    updatedAt: Scalar.Datetime.parse(value.updatedAt),
    kind: tmp,
    shop: {
      __typename: value$2.__typename,
      id: value$2.id
    },
    companyName: !(value$3 == null) ? value$3 : undefined,
    siret: !(value$4 == null) ? value$4 : undefined,
    intraCommunityVAT: !(value$5 == null) ? value$5 : undefined,
    invoicingEndpointId: !(value$6 == null) ? value$6 : undefined,
    invoicingEndpointIdSchemeCode: !(value$7 == null) ? value$7 : undefined,
    invoicingEndpointIdSchemeType: tmp$1,
    firstName: !(value$9 == null) ? value$9 : undefined,
    lastName: !(value$10 == null) ? value$10 : undefined,
    dateOfBirth: !(value$11 == null) ? Scalar.Datetime.parse(value$11) : undefined,
    email: !(value$12 == null) ? value$12 : undefined,
    phoneNumber: !(value$13 == null) ? value$13 : undefined,
    mobileNumber: !(value$14 == null) ? value$14 : undefined,
    price: !(value$15 == null) ? {
      __typename: value$15.__typename,
      id: value$15.id,
      name: value$15.name,
      taxIncluded: value$15.taxIncluded
    } : undefined,
    locations: value$16.map(value => {
      let value$1 = value.archivedAt;
      let value$2 = value.recipient;
      let value$3 = value.address;
      let value$4 = value.postalCode;
      let value$5 = value.city;
      let value$6 = value.country;
      let value$7 = value.defaults;
      return {
        __typename: value.__typename,
        id: value.id,
        archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
        label: value.label,
        recipient: !(value$2 == null) ? value$2 : undefined,
        address: !(value$3 == null) ? value$3 : undefined,
        postalCode: !(value$4 == null) ? value$4 : undefined,
        city: !(value$5 == null) ? value$5 : undefined,
        country: !(value$6 == null) ? value$6 : undefined,
        defaults: value$7.map(value => {
          switch (value) {
            case "BILLING":
              return "BILLING";
            case "DELIVERY":
              return "DELIVERY";
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
        })
      };
    }),
    internalCode: !(value$17 == null) ? value$17 : undefined,
    note: !(value$18 == null) ? value$18 : undefined
  };
}
function serialize(value) {
  let value$1 = value.note;
  let note = value$1 !== undefined ? value$1 : null;
  let value$2 = value.internalCode;
  let internalCode = value$2 !== undefined ? value$2 : null;
  let value$3 = value.locations;
  let locations = value$3.map(value => {
    let value$1 = value.defaults;
    let defaults = value$1.map(value => {
      if (value === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    });
    let value$2 = value.country;
    let country = value$2 !== undefined ? value$2 : null;
    let value$3 = value.city;
    let city = value$3 !== undefined ? value$3 : null;
    let value$4 = value.postalCode;
    let postalCode = value$4 !== undefined ? value$4 : null;
    let value$5 = value.address;
    let address = value$5 !== undefined ? value$5 : null;
    let value$6 = value.recipient;
    let recipient = value$6 !== undefined ? value$6 : null;
    let value$7 = value.label;
    let value$8 = value.archivedAt;
    let archivedAt = value$8 !== undefined ? Scalar.Datetime.serialize(value$8) : null;
    let value$9 = value.id;
    let value$10 = value.__typename;
    return {
      __typename: value$10,
      id: value$9,
      archivedAt: archivedAt,
      label: value$7,
      recipient: recipient,
      address: address,
      postalCode: postalCode,
      city: city,
      country: country,
      defaults: defaults
    };
  });
  let value$4 = value.price;
  let price;
  if (value$4 !== undefined) {
    let value$5 = value$4.taxIncluded;
    let value$6 = value$4.name;
    let value$7 = value$4.id;
    let value$8 = value$4.__typename;
    price = {
      __typename: value$8,
      id: value$7,
      name: value$6,
      taxIncluded: value$5
    };
  } else {
    price = null;
  }
  let value$9 = value.mobileNumber;
  let mobileNumber = value$9 !== undefined ? value$9 : null;
  let value$10 = value.phoneNumber;
  let phoneNumber = value$10 !== undefined ? value$10 : null;
  let value$11 = value.email;
  let email = value$11 !== undefined ? value$11 : null;
  let value$12 = value.dateOfBirth;
  let dateOfBirth = value$12 !== undefined ? Scalar.Datetime.serialize(value$12) : null;
  let value$13 = value.lastName;
  let lastName = value$13 !== undefined ? value$13 : null;
  let value$14 = value.firstName;
  let firstName = value$14 !== undefined ? value$14 : null;
  let value$15 = value.invoicingEndpointIdSchemeType;
  let invoicingEndpointIdSchemeType = value$15 !== undefined ? value$15 === "BE_TVA" ? "BE_TVA" : value$15 === "FR_SIREN" ? "FR_SIREN" : value$15 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : value$15 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : value$15 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : null;
  let value$16 = value.invoicingEndpointIdSchemeCode;
  let invoicingEndpointIdSchemeCode = value$16 !== undefined ? value$16 : null;
  let value$17 = value.invoicingEndpointId;
  let invoicingEndpointId = value$17 !== undefined ? value$17 : null;
  let value$18 = value.intraCommunityVAT;
  let intraCommunityVAT = value$18 !== undefined ? value$18 : null;
  let value$19 = value.siret;
  let siret = value$19 !== undefined ? value$19 : null;
  let value$20 = value.companyName;
  let companyName = value$20 !== undefined ? value$20 : null;
  let value$21 = value.shop;
  let value$22 = value$21.id;
  let value$23 = value$21.__typename;
  let shop = {
    __typename: value$23,
    id: value$22
  };
  let value$24 = value.kind;
  let kind = value$24 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
  let value$25 = value.updatedAt;
  let value$26 = Scalar.Datetime.serialize(value$25);
  let value$27 = value.id;
  let value$28 = value.__typename;
  return {
    __typename: value$28,
    id: value$27,
    updatedAt: value$26,
    kind: kind,
    shop: shop,
    companyName: companyName,
    siret: siret,
    intraCommunityVAT: intraCommunityVAT,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    firstName: firstName,
    lastName: lastName,
    dateOfBirth: dateOfBirth,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    price: price,
    locations: locations,
    internalCode: internalCode,
    note: note
  };
}
function verifyArgsAndParse(_CustomerFormFragment, value) {
  return parse(value);
}
function verifyName(_fragmentName) {}
let CustomerFormFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
let Raw$1 = {};
let query$1 = Client.gql(["mutation createCustomer($customerInput: InputCreateCustomer!, $locationsInput: [InputCreateCustomerLocationTypeDef!])  {\ncreateCustomer(customerInput: $customerInput, locationsInput: $locationsInput)  {\n...CustomerFormFragment   \n}\n\n}\n", ""], query);
function parse$1(value) {
  let value$1 = value.createCustomer;
  return {
    createCustomer: parse(value$1)
  };
}
function serialize$1(value) {
  let value$1 = value.createCustomer;
  let createCustomer = serialize(value$1);
  return {
    createCustomer: createCustomer
  };
}
function serializeInputObjectInputCreateCustomer(inp) {
  let a = inp.kind;
  let a$1 = inp.priceId;
  let a$2 = inp.companyName;
  let a$3 = inp.intraCommunityVAT;
  let a$4 = inp.firstName;
  let a$5 = inp.lastName;
  let a$6 = inp.email;
  let a$7 = inp.phoneNumber;
  let a$8 = inp.mobileNumber;
  let a$9 = inp.note;
  let a$10 = inp.siret;
  let a$11 = inp.internalCode;
  let a$12 = inp.invoicingEndpointId;
  let a$13 = inp.invoicingEndpointIdSchemeCode;
  let a$14 = inp.invoicingEndpointIdSchemeType;
  let a$15 = inp.dateOfBirth;
  return {
    kind: a === "CONSUMER" ? "CONSUMER" : "BUSINESS",
    hasSubscribedToLoyaltyProgram: inp.hasSubscribedToLoyaltyProgram,
    shopId: inp.shopId,
    priceId: a$1 !== undefined ? a$1 : undefined,
    companyName: a$2 !== undefined ? a$2 : undefined,
    intraCommunityVAT: a$3 !== undefined ? a$3 : undefined,
    firstName: a$4 !== undefined ? a$4 : undefined,
    lastName: a$5 !== undefined ? a$5 : undefined,
    email: a$6 !== undefined ? a$6 : undefined,
    phoneNumber: a$7 !== undefined ? a$7 : undefined,
    mobileNumber: a$8 !== undefined ? a$8 : undefined,
    note: a$9 !== undefined ? a$9 : undefined,
    siret: a$10 !== undefined ? a$10 : undefined,
    internalCode: a$11 !== undefined ? a$11 : undefined,
    invoicingEndpointId: a$12 !== undefined ? a$12 : undefined,
    invoicingEndpointIdSchemeCode: a$13 !== undefined ? a$13 : undefined,
    invoicingEndpointIdSchemeType: a$14 !== undefined ? a$14 === "BE_TVA" ? "BE_TVA" : a$14 === "FR_SIREN" ? "FR_SIREN" : a$14 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : a$14 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : a$14 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : undefined,
    dateOfBirth: a$15 !== undefined ? a$15 : undefined
  };
}
function serializeInputObjectInputCreateCustomerLocationTypeDef(inp) {
  let a = inp.defaults;
  let a$1 = inp.recipient;
  let a$2 = inp.address;
  let a$3 = inp.postalCode;
  let a$4 = inp.city;
  let a$5 = inp.country;
  return {
    label: inp.label,
    defaults: a.map(b => {
      if (b === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    }),
    recipient: a$1 !== undefined ? a$1 : undefined,
    address: a$2 !== undefined ? a$2 : undefined,
    postalCode: a$3 !== undefined ? a$3 : undefined,
    city: a$4 !== undefined ? a$4 : undefined,
    country: a$5 !== undefined ? a$5 : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.locationsInput;
  return {
    customerInput: serializeInputObjectInputCreateCustomer(inp.customerInput),
    locationsInput: a !== undefined ? a.map(serializeInputObjectInputCreateCustomerLocationTypeDef) : undefined
  };
}
function makeVariables(customerInput, locationsInput, param) {
  return {
    customerInput: customerInput,
    locationsInput: locationsInput
  };
}
function makeInputObjectInputCreateCustomer(kind, hasSubscribedToLoyaltyProgram, shopId, priceId, companyName, intraCommunityVAT, firstName, lastName, email, phoneNumber, mobileNumber, note, siret, internalCode, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType, dateOfBirth, param) {
  return {
    kind: kind,
    hasSubscribedToLoyaltyProgram: hasSubscribedToLoyaltyProgram,
    shopId: shopId,
    priceId: priceId,
    companyName: companyName,
    intraCommunityVAT: intraCommunityVAT,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    note: note,
    siret: siret,
    internalCode: internalCode,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    dateOfBirth: dateOfBirth
  };
}
function makeInputObjectInputCreateCustomerLocationTypeDef(label, defaults, recipient, address, postalCode, city, country, param) {
  return {
    label: label,
    defaults: defaults,
    recipient: recipient,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country
  };
}
let CustomerFormCreateMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateCustomer: serializeInputObjectInputCreateCustomer,
  serializeInputObjectInputCreateCustomerLocationTypeDef: serializeInputObjectInputCreateCustomerLocationTypeDef,
  makeVariables: makeVariables,
  makeInputObjectInputCreateCustomer: makeInputObjectInputCreateCustomer,
  makeInputObjectInputCreateCustomerLocationTypeDef: makeInputObjectInputCreateCustomerLocationTypeDef
};
let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});
let use = include.use;
let CustomerFormCreateMutation_useWithVariables = include.useWithVariables;
let CustomerFormCreateMutation = {
  CustomerFormCreateMutation_inner: CustomerFormCreateMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateCustomer: serializeInputObjectInputCreateCustomer,
  serializeInputObjectInputCreateCustomerLocationTypeDef: serializeInputObjectInputCreateCustomerLocationTypeDef,
  makeVariables: makeVariables,
  makeInputObjectInputCreateCustomer: makeInputObjectInputCreateCustomer,
  makeInputObjectInputCreateCustomerLocationTypeDef: makeInputObjectInputCreateCustomerLocationTypeDef,
  use: use,
  useWithVariables: CustomerFormCreateMutation_useWithVariables
};
let Raw$2 = {};
let query$2 = Client.gql(["mutation updateCustomer($id: ID!, $customerInput: InputUpdateCustomerTypeDef, $locationsInput: [InputCreateOrUpdateCustomerLocationTypeDef!])  {\nupdateCustomer(id: $id, customerInput: $customerInput, locationsInput: $locationsInput)  {\n...CustomerFormFragment   \n}\n\n}\n", ""], query);
function parse$2(value) {
  let value$1 = value.updateCustomer;
  return {
    updateCustomer: parse(value$1)
  };
}
function serialize$2(value) {
  let value$1 = value.updateCustomer;
  let updateCustomer = serialize(value$1);
  return {
    updateCustomer: updateCustomer
  };
}
function serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(inp) {
  let a = inp.id;
  let a$1 = inp.defaults;
  let a$2 = inp.recipient;
  let a$3 = inp.address;
  let a$4 = inp.postalCode;
  let a$5 = inp.city;
  let a$6 = inp.country;
  return {
    id: a !== undefined ? a : undefined,
    label: inp.label,
    defaults: a$1.map(b => {
      if (b === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    }),
    recipient: a$2 !== undefined ? a$2 : undefined,
    address: a$3 !== undefined ? a$3 : undefined,
    postalCode: a$4 !== undefined ? a$4 : undefined,
    city: a$5 !== undefined ? a$5 : undefined,
    country: a$6 !== undefined ? a$6 : undefined
  };
}
function serializeInputObjectInputUpdateCustomerTypeDef(inp) {
  let a = inp.priceId;
  let a$1 = inp.companyName;
  let a$2 = inp.intraCommunityVAT;
  let a$3 = inp.firstName;
  let a$4 = inp.lastName;
  let a$5 = inp.email;
  let a$6 = inp.phoneNumber;
  let a$7 = inp.mobileNumber;
  let a$8 = inp.note;
  let a$9 = inp.siret;
  let a$10 = inp.internalCode;
  let a$11 = inp.invoicingEndpointId;
  let a$12 = inp.invoicingEndpointIdSchemeCode;
  let a$13 = inp.invoicingEndpointIdSchemeType;
  let a$14 = inp.dateOfBirth;
  return {
    priceId: a !== undefined ? a : undefined,
    companyName: a$1 !== undefined ? a$1 : undefined,
    intraCommunityVAT: a$2 !== undefined ? a$2 : undefined,
    firstName: a$3 !== undefined ? a$3 : undefined,
    lastName: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    phoneNumber: a$6 !== undefined ? a$6 : undefined,
    mobileNumber: a$7 !== undefined ? a$7 : undefined,
    note: a$8 !== undefined ? a$8 : undefined,
    siret: a$9 !== undefined ? a$9 : undefined,
    internalCode: a$10 !== undefined ? a$10 : undefined,
    invoicingEndpointId: a$11 !== undefined ? a$11 : undefined,
    invoicingEndpointIdSchemeCode: a$12 !== undefined ? a$12 : undefined,
    invoicingEndpointIdSchemeType: a$13 !== undefined ? a$13 === "BE_TVA" ? "BE_TVA" : a$13 === "FR_SIREN" ? "FR_SIREN" : a$13 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : a$13 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : a$13 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE" : undefined,
    dateOfBirth: a$14 !== undefined ? a$14 : undefined
  };
}
function serializeVariables$1(inp) {
  let a = inp.customerInput;
  let a$1 = inp.locationsInput;
  return {
    id: inp.id,
    customerInput: a !== undefined ? serializeInputObjectInputUpdateCustomerTypeDef(a) : undefined,
    locationsInput: a$1 !== undefined ? a$1.map(serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef) : undefined
  };
}
function makeVariables$1(id, customerInput, locationsInput, param) {
  return {
    id: id,
    customerInput: customerInput,
    locationsInput: locationsInput
  };
}
function makeInputObjectInputUpdateCustomerTypeDef(priceId, companyName, intraCommunityVAT, firstName, lastName, email, phoneNumber, mobileNumber, note, siret, internalCode, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType, dateOfBirth, param) {
  return {
    priceId: priceId,
    companyName: companyName,
    intraCommunityVAT: intraCommunityVAT,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    note: note,
    siret: siret,
    internalCode: internalCode,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    dateOfBirth: dateOfBirth
  };
}
function makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(id, label, defaults, recipient, address, postalCode, city, country, param) {
  return {
    id: id,
    label: label,
    defaults: defaults,
    recipient: recipient,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country
  };
}
let CustomerFormUpdateMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef,
  makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef
};
let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let CustomerFormUpdateMutation_useWithVariables = include$1.useWithVariables;
let CustomerFormUpdateMutation = {
  CustomerFormUpdateMutation_inner: CustomerFormUpdateMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef,
  makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  use: use$1,
  useWithVariables: CustomerFormUpdateMutation_useWithVariables
};
let Raw$3 = {};
let query$3 = Client.gql(["mutation CustomerFormLoyaltySubscribeMutation($id: ID!, $isLoyaltyConsentGiven: Boolean!)  {\nsubscribeCustomerToLoyaltyProgram(id: $id, isLoyaltyConsentGiven: $isLoyaltyConsentGiven)  {\n__typename  \nid  \nhasSubscribedToLoyaltyProgram  \n}\n\n}\n"]);
function parse$3(value) {
  let value$1 = value.subscribeCustomerToLoyaltyProgram;
  return {
    subscribeCustomerToLoyaltyProgram: {
      __typename: value$1.__typename,
      id: value$1.id,
      hasSubscribedToLoyaltyProgram: value$1.hasSubscribedToLoyaltyProgram
    }
  };
}
function serialize$3(value) {
  let value$1 = value.subscribeCustomerToLoyaltyProgram;
  let value$2 = value$1.hasSubscribedToLoyaltyProgram;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let subscribeCustomerToLoyaltyProgram = {
    __typename: value$4,
    id: value$3,
    hasSubscribedToLoyaltyProgram: value$2
  };
  return {
    subscribeCustomerToLoyaltyProgram: subscribeCustomerToLoyaltyProgram
  };
}
function serializeVariables$2(inp) {
  return {
    id: inp.id,
    isLoyaltyConsentGiven: inp.isLoyaltyConsentGiven
  };
}
function makeVariables$2(id, isLoyaltyConsentGiven, param) {
  return {
    id: id,
    isLoyaltyConsentGiven: isLoyaltyConsentGiven
  };
}
let CustomerFormLoyaltySubscribeMutation_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};
let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2
});
let use$2 = include$2.use;
let CustomerFormLoyaltySubscribeMutation_useWithVariables = include$2.useWithVariables;
let CustomerFormLoyaltySubscribeMutation = {
  CustomerFormLoyaltySubscribeMutation_inner: CustomerFormLoyaltySubscribeMutation_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: CustomerFormLoyaltySubscribeMutation_useWithVariables
};
let Raw$4 = {};
let query$4 = Client.gql(["query CustomerFormShopLoyaltyQuery($id: ID!)  {\nshop(id: $id)  {\n__typename  \nid  \nloyaltyWelcomePoints  \n}\n\n}\n"]);
function parse$4(value) {
  let value$1 = value.shop;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.loyaltyWelcomePoints;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      loyaltyWelcomePoints: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
    shop: tmp
  };
}
function serialize$4(value) {
  let value$1 = value.shop;
  let shop;
  if (value$1 !== undefined) {
    let value$2 = value$1.loyaltyWelcomePoints;
    let loyaltyWelcomePoints = value$2 !== undefined ? value$2 : null;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    shop = {
      __typename: value$4,
      id: value$3,
      loyaltyWelcomePoints: loyaltyWelcomePoints
    };
  } else {
    shop = null;
  }
  return {
    shop: shop
  };
}
function serializeVariables$3(inp) {
  return {
    id: inp.id
  };
}
function makeVariables$3(id, param) {
  return {
    id: id
  };
}
let CustomerFormShopLoyaltyQuery_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};
let include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3
});
let use$3 = include$3.use;
let CustomerFormShopLoyaltyQuery_refetchQueryDescription = include$3.refetchQueryDescription;
let CustomerFormShopLoyaltyQuery_useLazy = include$3.useLazy;
let CustomerFormShopLoyaltyQuery_useLazyWithVariables = include$3.useLazyWithVariables;
let CustomerFormShopLoyaltyQuery = {
  CustomerFormShopLoyaltyQuery_inner: CustomerFormShopLoyaltyQuery_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  refetchQueryDescription: CustomerFormShopLoyaltyQuery_refetchQueryDescription,
  use: use$3,
  useLazy: CustomerFormShopLoyaltyQuery_useLazy,
  useLazyWithVariables: CustomerFormShopLoyaltyQuery_useLazyWithVariables
};
let Raw$5 = {};
let query$5 = Client.gql(["query CustomerFormQuery($id: ID!)  {\ncustomer(id: $id)  {\n...CustomerFormFragment   \n}\n\n}\n", ""], query);
function parse$5(value) {
  let value$1 = value.customer;
  return {
    customer: parse(value$1)
  };
}
function serialize$5(value) {
  let value$1 = value.customer;
  let customer = serialize(value$1);
  return {
    customer: customer
  };
}
function serializeVariables$4(inp) {
  return {
    id: inp.id
  };
}
function makeVariables$4(id, param) {
  return {
    id: id
  };
}
let CustomerFormQuery_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4
};
let include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$5,
  Raw: Raw$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4
});
let use$4 = include$4.use;
let CustomerFormQuery_refetchQueryDescription = include$4.refetchQueryDescription;
let CustomerFormQuery_useLazy = include$4.useLazy;
let CustomerFormQuery_useLazyWithVariables = include$4.useLazyWithVariables;
let CustomerFormQuery = {
  CustomerFormQuery_inner: CustomerFormQuery_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  refetchQueryDescription: CustomerFormQuery_refetchQueryDescription,
  use: use$4,
  useLazy: CustomerFormQuery_useLazy,
  useLazyWithVariables: CustomerFormQuery_useLazyWithVariables
};
let Raw$6 = {};
let query$6 = Client.gql(["query CustomerFormPricesQuery($filterBy: InputPricesQueryFilter)  {\nprices(first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ntaxIncluded  \n}\n\n}\n\n}\n\n}\n"]);
function parse$6(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            taxIncluded: value$1.taxIncluded
          }
        };
      })
    }
  };
}
function serialize$6(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.taxIncluded;
    let value$3 = value$1.name;
    let value$4 = value$1.id;
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      id: value$4,
      name: value$3,
      taxIncluded: value$2
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let prices = {
    __typename: value$3,
    edges: edges
  };
  return {
    prices: prices
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectInputPricesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? a$1 === "ONLY" ? "ONLY" : a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined
  };
}
function serializeVariables$5(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputPricesQueryFilter(a) : undefined
  };
}
function makeVariables$5(filterBy) {
  return {
    filterBy: filterBy
  };
}
function makeInputObjectInputPricesQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}
let CustomerFormPricesQuery_inner = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables$5,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};
let include$5 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$6,
  Raw: Raw$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5
});
let use$5 = include$5.use;
let CustomerFormPricesQuery_refetchQueryDescription = include$5.refetchQueryDescription;
let CustomerFormPricesQuery_useLazy = include$5.useLazy;
let CustomerFormPricesQuery_useLazyWithVariables = include$5.useLazyWithVariables;
let CustomerFormPricesQuery = {
  CustomerFormPricesQuery_inner: CustomerFormPricesQuery_inner,
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables$5,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: CustomerFormPricesQuery_refetchQueryDescription,
  use: use$5,
  useLazy: CustomerFormPricesQuery_useLazy,
  useLazyWithVariables: CustomerFormPricesQuery_useLazyWithVariables
};
let Raw$7 = {};
let query$7 = Client.gql(["query CustomerFormDuplicateCheckQuery($search: String, $filterBy: InputCustomersQueryFilter)  {\ncustomers(search: $search, filterBy: $filterBy, first: 5)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nsiret  \nintraCommunityVAT  \nfirstName  \nlastName  \ncompanyName  \n}\n\n}\n\n}\n\n}\n"]);
function parse$7(value) {
  let value$1 = value.customers;
  let value$2 = value$1.edges;
  return {
    customers: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.siret;
        let value$3 = value$1.intraCommunityVAT;
        let value$4 = value$1.firstName;
        let value$5 = value$1.lastName;
        let value$6 = value$1.companyName;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            siret: !(value$2 == null) ? value$2 : undefined,
            intraCommunityVAT: !(value$3 == null) ? value$3 : undefined,
            firstName: !(value$4 == null) ? value$4 : undefined,
            lastName: !(value$5 == null) ? value$5 : undefined,
            companyName: !(value$6 == null) ? value$6 : undefined
          }
        };
      })
    }
  };
}
function serialize$7(value) {
  let value$1 = value.customers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.companyName;
    let companyName = value$2 !== undefined ? value$2 : null;
    let value$3 = value$1.lastName;
    let lastName = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.firstName;
    let firstName = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.intraCommunityVAT;
    let intraCommunityVAT = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.siret;
    let siret = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.id;
    let value$8 = value$1.__typename;
    let node = {
      __typename: value$8,
      id: value$7,
      siret: siret,
      intraCommunityVAT: intraCommunityVAT,
      firstName: firstName,
      lastName: lastName,
      companyName: companyName
    };
    let value$9 = value.__typename;
    return {
      __typename: value$9,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let customers = {
    __typename: value$3,
    edges: edges
  };
  return {
    customers: customers
  };
}
function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeInputObjectInputCustomersQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  let a$2 = inp.createdAt;
  let a$3 = inp.customerId;
  let a$4 = inp.kind;
  let a$5 = inp.hasSubscribedToLoyaltyProgram;
  let a$6 = inp.loyaltyPoints;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    archived: a$1 !== undefined ? a$1 === "ONLY" ? "ONLY" : a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined,
    createdAt: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    customerId: a$3 !== undefined ? serializeInputObjectInFilter$1(a$3) : undefined,
    kind: a$4 !== undefined ? serializeInputObjectInFilter$1(a$4) : undefined,
    hasSubscribedToLoyaltyProgram: a$5 !== undefined ? {
      _equals: a$5._equals
    } : undefined,
    loyaltyPoints: a$6 !== undefined ? serializeInputObjectNumberRangeFilter(a$6) : undefined
  };
}
function serializeVariables$6(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputCustomersQueryFilter(a$1) : undefined
  };
}
function makeVariables$6(search, filterBy) {
  return {
    search: search,
    filterBy: filterBy
  };
}
function makeInputObjectInputCustomersQueryFilter(shopIds, archived, createdAt, customerId, kind, hasSubscribedToLoyaltyProgram, loyaltyPoints, param) {
  return {
    shopIds: shopIds,
    archived: archived,
    createdAt: createdAt,
    customerId: customerId,
    kind: kind,
    hasSubscribedToLoyaltyProgram: hasSubscribedToLoyaltyProgram,
    loyaltyPoints: loyaltyPoints
  };
}
function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}
function makeDefaultVariables$1() {
  return {
    search: undefined,
    filterBy: undefined
  };
}
let CustomerFormDuplicateCheckQuery_inner = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables$6,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables$1
};
let include$6 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$7,
  Raw: Raw$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6
});
let use$6 = include$6.use;
let CustomerFormDuplicateCheckQuery_refetchQueryDescription = include$6.refetchQueryDescription;
let CustomerFormDuplicateCheckQuery_useLazy = include$6.useLazy;
let CustomerFormDuplicateCheckQuery_useLazyWithVariables = include$6.useLazyWithVariables;
let CustomerFormDuplicateCheckQuery = {
  CustomerFormDuplicateCheckQuery_inner: CustomerFormDuplicateCheckQuery_inner,
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables$6,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: CustomerFormDuplicateCheckQuery_refetchQueryDescription,
  use: use$6,
  useLazy: CustomerFormDuplicateCheckQuery_useLazy,
  useLazyWithVariables: CustomerFormDuplicateCheckQuery_useLazyWithVariables
};
function get(values, field) {
  switch (field) {
    case "ShopId":
      return values.shopId;
    case "Business":
      return values.business;
    case "BillingCountry":
      return values.billingCountry;
    case "CompanyName":
      return values.companyName;
    case "Siret":
      return values.siret;
    case "SiretIsDuplicate":
      return values.siretIsDuplicate;
    case "IntraCommunityVat":
      return values.intraCommunityVat;
    case "IntraCommunityVatIsDuplicate":
      return values.intraCommunityVatIsDuplicate;
    case "InvoicingEndpointFrenchKind":
      return values.invoicingEndpointFrenchKind;
    case "InvoicingEndpointSuffix":
      return values.invoicingEndpointSuffix;
    case "InvoicingEndpointRoutingCode":
      return values.invoicingEndpointRoutingCode;
    case "InvoicingEndpointBelgianKind":
      return values.invoicingEndpointBelgianKind;
    case "FirstName":
      return values.firstName;
    case "LastName":
      return values.lastName;
    case "DateOfBirth":
      return values.dateOfBirth;
    case "Email":
      return values.email;
    case "PhoneNumber":
      return values.phoneNumber;
    case "MobileNumber":
      return values.mobileNumber;
    case "LoyaltySubscribed":
      return values.loyaltySubscribed;
    case "PriceId":
      return values.priceId;
    case "InternalCode":
      return values.internalCode;
    case "Note":
      return values.note;
    case "Addresses":
      return values.addresses;
  }
}
function set(values, field, value) {
  switch (field) {
    case "ShopId":
      let newrecord = {
        ...values
      };
      newrecord.shopId = value;
      return newrecord;
    case "Business":
      let newrecord$1 = {
        ...values
      };
      newrecord$1.business = value;
      return newrecord$1;
    case "BillingCountry":
      let newrecord$2 = {
        ...values
      };
      newrecord$2.billingCountry = value;
      return newrecord$2;
    case "CompanyName":
      let newrecord$3 = {
        ...values
      };
      newrecord$3.companyName = value;
      return newrecord$3;
    case "Siret":
      let newrecord$4 = {
        ...values
      };
      newrecord$4.siret = value;
      return newrecord$4;
    case "SiretIsDuplicate":
      let newrecord$5 = {
        ...values
      };
      newrecord$5.siretIsDuplicate = value;
      return newrecord$5;
    case "IntraCommunityVat":
      let newrecord$6 = {
        ...values
      };
      newrecord$6.intraCommunityVat = value;
      return newrecord$6;
    case "IntraCommunityVatIsDuplicate":
      let newrecord$7 = {
        ...values
      };
      newrecord$7.intraCommunityVatIsDuplicate = value;
      return newrecord$7;
    case "InvoicingEndpointFrenchKind":
      let newrecord$8 = {
        ...values
      };
      newrecord$8.invoicingEndpointFrenchKind = value;
      return newrecord$8;
    case "InvoicingEndpointSuffix":
      let newrecord$9 = {
        ...values
      };
      newrecord$9.invoicingEndpointSuffix = value;
      return newrecord$9;
    case "InvoicingEndpointRoutingCode":
      let newrecord$10 = {
        ...values
      };
      newrecord$10.invoicingEndpointRoutingCode = value;
      return newrecord$10;
    case "InvoicingEndpointBelgianKind":
      let newrecord$11 = {
        ...values
      };
      newrecord$11.invoicingEndpointBelgianKind = value;
      return newrecord$11;
    case "FirstName":
      let newrecord$12 = {
        ...values
      };
      newrecord$12.firstName = value;
      return newrecord$12;
    case "LastName":
      let newrecord$13 = {
        ...values
      };
      newrecord$13.lastName = value;
      return newrecord$13;
    case "DateOfBirth":
      let newrecord$14 = {
        ...values
      };
      newrecord$14.dateOfBirth = value;
      return newrecord$14;
    case "Email":
      let newrecord$15 = {
        ...values
      };
      newrecord$15.email = value;
      return newrecord$15;
    case "PhoneNumber":
      let newrecord$16 = {
        ...values
      };
      newrecord$16.phoneNumber = value;
      return newrecord$16;
    case "MobileNumber":
      let newrecord$17 = {
        ...values
      };
      newrecord$17.mobileNumber = value;
      return newrecord$17;
    case "LoyaltySubscribed":
      let newrecord$18 = {
        ...values
      };
      newrecord$18.loyaltySubscribed = value;
      return newrecord$18;
    case "PriceId":
      let newrecord$19 = {
        ...values
      };
      newrecord$19.priceId = value;
      return newrecord$19;
    case "InternalCode":
      let newrecord$20 = {
        ...values
      };
      newrecord$20.internalCode = value;
      return newrecord$20;
    case "Note":
      let newrecord$21 = {
        ...values
      };
      newrecord$21.note = value;
      return newrecord$21;
    case "Addresses":
      let newrecord$22 = {
        ...values
      };
      newrecord$22.addresses = value;
      return newrecord$22;
  }
}
let Lenses = {
  get: get,
  set: set
};
let CustomerFormLenses = {
  Lenses: Lenses,
  get: get,
  set: set
};
let CustomerForm = Form.Make({
  get: get,
  set: set
});
function notEmptyResult(value) {
  if (value.trim() === "") {
    return {
      TAG: "Error",
      _0: I18n.t("Please fulfill this field.")
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}
function orEmptyString(value) {
  return Stdlib_Option.getOr(value, "");
}
function keepWhen(value, condition) {
  if (condition) {
    return value;
  }
}
function orNull(option) {
  return Stdlib_Option.getOr(option, null);
}
function normalizeIdentifier(value) {
  return value.replace(/[^A-Za-z0-9]+/g, "").toUpperCase();
}
let companyHeadOfficeAddressKey = "company-head-office";
function compactAddressPart(value) {
  return value.toLowerCase().normalize("NFD").replace(/[^a-z0-9]+/g, "");
}
function headOfficeAddressToAdd(addresses, company) {
  let street = StringHelpers.stripEmptyString(company.street);
  if (street === undefined) {
    return;
  }
  let alreadyKnown = addresses.some(address => {
    if (compactAddressPart(address.street) === compactAddressPart(street)) {
      return compactAddressPart(address.postalCode) === compactAddressPart(company.postalCode);
    } else {
      return false;
    }
  });
  if (alreadyKnown) {
    return;
  }
  let newrecord = {
    ...CustomerAddressEditModal.makeAddress(undefined, false)
  };
  return newrecord.isBilling = addresses.length === 0, newrecord.city = company.city, newrecord.postalCode = company.postalCode, newrecord.street = street, newrecord.recipient = company.corporateName, newrecord.label = I18n.t("Head office"), newrecord;
}
let initialValues = {
  companyName: undefined,
  firstName: undefined,
  lastName: undefined,
  addedAddressKey: undefined,
  companyNameConfirmed: false,
  suggestionUsed: false
};
let context = React.createContext([initialValues, param => {}]);
let make = context.Provider;
let Provider = {
  make: make
};
function use$7() {
  return React.useContext(context);
}
function keepOverwritten(previousValue, value) {
  let match = previousValue.trim();
  let match$1 = value.trim();
  if (match === "" || match$1 === "" || match === match$1) {
    return;
  } else {
    return match;
  }
}
function CustomerFormPage$CustomerFormAutoCompletion$AddedAddressBanner(props) {
  return JsxRuntime.jsx(NextBanner.make, {
    children: JsxRuntime.jsx(NextBanner.Text.make, {
      text: I18n.t("customer_form_page.added_address.text")
    }),
    variation: "important"
  });
}
let AddedAddressBanner = {
  make: CustomerFormPage$CustomerFormAutoCompletion$AddedAddressBanner
};
let i18nPrefix = "customer_form_page.overwritten_value.";
function CustomerFormPage$CustomerFormAutoCompletion$Banner(props) {
  return JsxRuntime.jsxs(NextBanner.make, {
    children: [JsxRuntime.jsx(NextBanner.Text.make, {
      text: I18n.template(I18n.t(i18nPrefix + "text"), {
        value: props.previousValue
      }, undefined)
    }), JsxRuntime.jsx(NextBanner.Text.make, {
      text: " — "
    }), JsxRuntime.jsx(NextBanner.Text.make, {
      text: I18n.t(i18nPrefix + "restore"),
      onPress: props.onRestore
    })],
    variation: "important",
    compact: true,
    grow: true
  });
}
let Banner = {
  i18nPrefix: i18nPrefix,
  make: CustomerFormPage$CustomerFormAutoCompletion$Banner
};
let CustomerFormAutoCompletion = {
  initialValues: initialValues,
  context: context,
  Provider: Provider,
  use: use$7,
  keepOverwritten: keepOverwritten,
  AddedAddressBanner: AddedAddressBanner,
  Banner: Banner
};
function overwrittenValueBanner(previousValue, currentValue, onRestore) {
  if (previousValue !== undefined && previousValue !== currentValue.trim()) {
    return JsxRuntime.jsx(CustomerFormPage$CustomerFormAutoCompletion$Banner, {
      previousValue: previousValue,
      onRestore: () => onRestore(previousValue)
    });
  } else {
    return null;
  }
}
function billingAddressCountryCode(addresses) {
  return Stdlib_Option.map(addresses.find(address => address.isBilling), address => CountryCode.parseIso3166Alpha2(address.country));
}
function billingCountryFromIdentifiers(siret, intraCommunityVat) {
  let match = StringHelpers.stripEmptyString(siret);
  let match$1 = StringHelpers.stripEmptyString(intraCommunityVat);
  if (match !== undefined) {
    return "France";
  } else if (match$1 !== undefined) {
    return Stdlib_Option.orElse(Stdlib_Option.flatMap(CompanyLegalNumber.Vat.countryCode(match$1), fromCountry), "Other");
  } else {
    return;
  }
}
function defaultBillingCountry(shopCountry, addresses, siret, intraCommunityVat) {
  return Stdlib_Option.getOr(Stdlib_Option.orElse(Stdlib_Option.orElse(billingCountryFromIdentifiers(siret, intraCommunityVat), Stdlib_Option.flatMap(billingAddressCountryCode(addresses), fromCountryCode)), fromCountryCode(CountryCode.parseIso3166Alpha2(shopCountry))), "France");
}
function mismatchedBillingAddressCountry(billingCountry, addresses) {
  return Stdlib_Option.flatMap(Stdlib_Option.flatMap(billingAddressCountryCode(addresses), fromCountryCode), addressCountry => {
    if (billingCountry !== undefined && billingCountry !== addressCountry) {
      return addressCountry;
    }
  });
}
function isFrenchBilling(billingCountry) {
  if (billingCountry === undefined) {
    return false;
  }
  switch (billingCountry) {
    case "France":
      return true;
    case "Belgium":
    case "Other":
      return false;
  }
}
function resetCompanyDerivedFields(values) {
  let newrecord = {
    ...values
  };
  newrecord.addresses = values.addresses.filter(address => address.key !== companyHeadOfficeAddressKey);
  newrecord.lastName = "";
  newrecord.firstName = "";
  newrecord.invoicingEndpointBelgianKind = "BceNumber";
  newrecord.invoicingEndpointRoutingCode = "";
  newrecord.invoicingEndpointSuffix = "";
  newrecord.invoicingEndpointFrenchKind = "Siren";
  newrecord.intraCommunityVatIsDuplicate = false;
  newrecord.intraCommunityVat = "";
  newrecord.siretIsDuplicate = false;
  newrecord.siret = "";
  return newrecord;
}
function resetBillingFields(values) {
  let newrecord = {
    ...values
  };
  newrecord.invoicingEndpointBelgianKind = "BceNumber";
  newrecord.invoicingEndpointRoutingCode = "";
  newrecord.invoicingEndpointSuffix = "";
  newrecord.invoicingEndpointFrenchKind = "Siren";
  newrecord.siretIsDuplicate = false;
  newrecord.siret = "";
  return newrecord;
}
function invoicingEndpointFromValues(values) {
  let match = values.billingCountry;
  if (match === undefined) {
    return;
  }
  switch (match) {
    case "France":
      let siret = StringHelpers.stripEmptyString(values.siret);
      if (siret !== undefined) {
        return ElectronicInvoicing.InvoicingEndpoint.French.makeEndpoint(values.invoicingEndpointFrenchKind, siret, values.invoicingEndpointSuffix, values.invoicingEndpointRoutingCode);
      } else {
        return;
      }
    case "Belgium":
      let vatNumber = StringHelpers.stripEmptyString(values.intraCommunityVat);
      if (vatNumber !== undefined) {
        return ElectronicInvoicing.InvoicingEndpoint.Belgian.makeEndpoint(values.invoicingEndpointBelgianKind, vatNumber);
      } else {
        return;
      }
    case "Other":
      return;
  }
}
function addressesFromLocations(locations) {
  return locations.filter(location => Stdlib_Option.isNone(location.archivedAt)).map(location => ({
    id: location.id,
    key: Uuid.v4(),
    label: location.label,
    recipient: Stdlib_Option.getOr(location.recipient, ""),
    street: Stdlib_Option.getOr(location.address, ""),
    postalCode: Stdlib_Option.getOr(location.postalCode, ""),
    city: Stdlib_Option.getOr(location.city, ""),
    country: Stdlib_Option.getOr(location.country, ""),
    isBilling: location.defaults.some(value => value === "BILLING"),
    isDelivery: location.defaults.some(value => value === "DELIVERY")
  }));
}
function customerFormSchema(withInformationOpt, param) {
  let withInformation = withInformationOpt !== undefined ? withInformationOpt : true;
  let informationRules = [{
    TAG: "Custom",
    _0: "BillingCountry",
    _1: param => {
      if (param.business && param.billingCountry === undefined) {
        return notEmptyResult("");
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "Custom",
    _0: "FirstName",
    _1: param => {
      if (param.business || param.firstName.trim() !== "" || param.lastName.trim() !== "") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return notEmptyResult("");
      }
    }
  }, {
    TAG: "Custom",
    _0: "LastName",
    _1: param => {
      if (param.business || param.firstName.trim() !== "" || param.lastName.trim() !== "") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return notEmptyResult("");
      }
    }
  }, {
    TAG: "Custom",
    _0: "CompanyName",
    _1: param => {
      if (param.business) {
        return notEmptyResult(param.companyName);
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "Custom",
    _0: "Siret",
    _1: param => {
      let match = param.business && isFrenchBilling(param.billingCountry);
      let match$1 = param.siret.trim();
      if (match && match$1 !== "") {
        if (CompanyLegalNumber.French.isValidSiret(match$1)) {
          if (param.siretIsDuplicate) {
            return {
              TAG: "Error",
              _0: ""
            };
          } else {
            return {
              TAG: "Ok",
              _0: undefined
            };
          }
        } else {
          return {
            TAG: "Error",
            _0: I18n.t("siret_input_field.error_message")
          };
        }
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "Custom",
    _0: "IntraCommunityVat",
    _1: param => {
      let match = param.intraCommunityVat.trim();
      if (param.business && match !== "") {
        if (CompanyLegalNumber.Vat.isValid(match)) {
          if (param.intraCommunityVatIsDuplicate) {
            return {
              TAG: "Error",
              _0: I18n.t("customer_new_page.billing_fieldset.vat_already_used")
            };
          } else {
            return {
              TAG: "Ok",
              _0: undefined
            };
          }
        } else {
          return {
            TAG: "Error",
            _0: I18n.t("customer_new_page.billing_fieldset.vat_invalid_format")
          };
        }
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "OptionalEmail",
    _0: "Email"
  }, {
    TAG: "Custom",
    _0: "Email",
    _1: param => {
      if (!param.business && param.loyaltySubscribed) {
        return notEmptyResult(param.email);
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "Custom",
    _0: "InvoicingEndpointSuffix",
    _1: param => {
      if (param.business && isFrenchBilling(param.billingCountry)) {
        return ElectronicInvoicing.InvoicingEndpoint.French.validateSuffix(param.invoicingEndpointFrenchKind, param.invoicingEndpointSuffix);
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }, {
    TAG: "Custom",
    _0: "InvoicingEndpointRoutingCode",
    _1: param => {
      if (param.business && isFrenchBilling(param.billingCountry)) {
        return ElectronicInvoicing.InvoicingEndpoint.French.validateRoutingCode(param.invoicingEndpointFrenchKind, param.invoicingEndpointRoutingCode);
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }];
  return [{
    TAG: "StringNotEmpty",
    _0: "ShopId"
  }].concat(withInformation ? informationRules : []);
}
function customerFormInitialValues(shopId, shopCountry, business) {
  return {
    shopId: shopId,
    business: business,
    billingCountry: defaultBillingCountry(shopCountry, [], "", ""),
    companyName: "",
    siret: "",
    siretIsDuplicate: false,
    intraCommunityVat: "",
    intraCommunityVatIsDuplicate: false,
    invoicingEndpointFrenchKind: "Siren",
    invoicingEndpointSuffix: "",
    invoicingEndpointRoutingCode: "",
    invoicingEndpointBelgianKind: "BceNumber",
    firstName: "",
    lastName: "",
    dateOfBirth: undefined,
    email: "",
    phoneNumber: "",
    mobileNumber: "",
    loyaltySubscribed: false,
    priceId: "",
    internalCode: "",
    note: "",
    addresses: []
  };
}
function customerFormInitialValuesFromQueryResult(shopCountry, queryResult) {
  let match = ElectronicInvoicing.InvoicingEndpoint.French.fromEndpoint(queryResult.invoicingEndpointIdSchemeType, queryResult.invoicingEndpointId);
  let addresses = addressesFromLocations(queryResult.locations);
  return {
    shopId: queryResult.shop.id,
    business: queryResult.kind === "BUSINESS",
    billingCountry: defaultBillingCountry(shopCountry, addresses, Stdlib_Option.getOr(queryResult.siret, ""), Stdlib_Option.getOr(queryResult.intraCommunityVAT, "")),
    companyName: Stdlib_Option.getOr(queryResult.companyName, ""),
    siret: Stdlib_Option.getOr(queryResult.siret, ""),
    siretIsDuplicate: false,
    intraCommunityVat: Stdlib_Option.getOr(queryResult.intraCommunityVAT, ""),
    intraCommunityVatIsDuplicate: false,
    invoicingEndpointFrenchKind: match[0],
    invoicingEndpointSuffix: match[1],
    invoicingEndpointRoutingCode: match[2],
    invoicingEndpointBelgianKind: Stdlib_Option.getOr(Stdlib_Option.flatMap(queryResult.invoicingEndpointIdSchemeType, ElectronicInvoicing.InvoicingEndpoint.Belgian.fromSchemeType), "BceNumber"),
    firstName: Stdlib_Option.getOr(queryResult.firstName, ""),
    lastName: Stdlib_Option.getOr(queryResult.lastName, ""),
    dateOfBirth: queryResult.dateOfBirth,
    email: Stdlib_Option.getOr(queryResult.email, ""),
    phoneNumber: Stdlib_Option.getOr(queryResult.phoneNumber, ""),
    mobileNumber: Stdlib_Option.getOr(queryResult.mobileNumber, ""),
    loyaltySubscribed: false,
    priceId: Stdlib_Option.mapOr(queryResult.price, "", price => price.id),
    internalCode: Stdlib_Option.getOr(queryResult.internalCode, ""),
    note: Stdlib_Option.getOr(queryResult.note, ""),
    addresses: addresses
  };
}
function createMutationVariablesFromFormValues(values) {
  let business = values.business;
  let withSiret = business && isFrenchBilling(values.billingCountry);
  let invoicingEndpoint = business ? invoicingEndpointFromValues(values) : undefined;
  let value = StringHelpers.stripEmptyString(values.companyName);
  let value$1 = StringHelpers.stripEmptyString(values.intraCommunityVat);
  let value$2 = StringHelpers.stripEmptyString(values.siret);
  let value$3 = Stdlib_Option.map(values.dateOfBirth, Scalar.Datetime.serialize);
  let addresses = values.addresses;
  return {
    customerInput: makeInputObjectInputCreateCustomer(business ? "BUSINESS" : "CONSUMER", false, values.shopId, Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.priceId), null), business ? value : undefined, business ? value$1 : undefined, values.firstName.trim(), values.lastName.trim(), StringHelpers.stripEmptyString(values.email), StringHelpers.stripEmptyString(values.phoneNumber), StringHelpers.stripEmptyString(values.mobileNumber), StringHelpers.stripEmptyString(values.note), withSiret ? value$2 : undefined, StringHelpers.stripEmptyString(values.internalCode), Stdlib_Option.map(invoicingEndpoint, param => param.endpointId), Stdlib_Option.map(invoicingEndpoint, param => param.schemeCode), Stdlib_Option.flatMap(invoicingEndpoint, param => param.schemeType), !business ? value$3 : undefined, undefined),
    locationsInput: addresses.length !== 0 ? addresses.map(address => makeInputObjectInputCreateCustomerLocationTypeDef(address.label, CustomerAddressEditModal.defaults(address), StringHelpers.stripEmptyString(address.recipient), StringHelpers.stripEmptyString(address.street), StringHelpers.stripEmptyString(address.postalCode), StringHelpers.stripEmptyString(address.city), StringHelpers.stripEmptyString(address.country), undefined)) : undefined
  };
}
function locationsInputFromAddresses(addresses) {
  return addresses.map(address => makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(address.id, address.label, CustomerAddressEditModal.defaults(address), StringHelpers.stripEmptyString(address.recipient), StringHelpers.stripEmptyString(address.street), StringHelpers.stripEmptyString(address.postalCode), StringHelpers.stripEmptyString(address.city), StringHelpers.stripEmptyString(address.country), undefined));
}
function updateMutationVariablesFromIdAndFormValues(id, values) {
  let business = values.business;
  let withSiret = business && isFrenchBilling(values.billingCountry);
  let invoicingEndpoint = business ? invoicingEndpointFromValues(values) : undefined;
  let value = StringHelpers.stripEmptyString(values.companyName);
  let value$1 = StringHelpers.stripEmptyString(values.intraCommunityVat);
  let value$2 = StringHelpers.stripEmptyString(values.siret);
  let value$3 = Stdlib_Option.map(values.dateOfBirth, Scalar.Datetime.serialize);
  return {
    id: id,
    customerInput: makeInputObjectInputUpdateCustomerTypeDef(Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.priceId), null), Stdlib_Option.getOr(business ? value : undefined, null), Stdlib_Option.getOr(business ? value$1 : undefined, null), values.firstName.trim(), values.lastName.trim(), Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.email), null), Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.phoneNumber), null), Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.mobileNumber), null), Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.note), null), Stdlib_Option.getOr(withSiret ? value$2 : undefined, null), Stdlib_Option.getOr(StringHelpers.stripEmptyString(values.internalCode), null), Stdlib_Option.getOr(Stdlib_Option.map(invoicingEndpoint, param => param.endpointId), null), Stdlib_Option.getOr(Stdlib_Option.map(invoicingEndpoint, param => param.schemeCode), null), Stdlib_Option.getOr(Stdlib_Option.flatMap(invoicingEndpoint, param => param.schemeType), null), Stdlib_Option.getOr(!business ? value$3 : undefined, null), undefined),
    locationsInput: locationsInputFromAddresses(values.addresses)
  };
}
function CustomerFormPage$CustomerFormShopFieldset(props) {
  let shops = Auth.useShops();
  let tmp;
  if (shops.length <= 4) {
    let shopsItems = shops.map(shop => ({
      value: shop.id,
      title: shop.name,
      illustrationSvg: JsxRuntime.jsx("img", {
        style: {
          height: "100%",
          width: "auto",
          objectFit: "contain"
        },
        alt: "",
        src: Illustration.storeSrc
      }),
      endElement: JsxRuntime.jsx(Auth__Types.ShopKind.Badge.make, {
        value: shop.kind,
        size: "normal"
      })
    }));
    tmp = JsxRuntime.jsx(CustomerForm.InputRadioCardGroup.make, {
      field: "ShopId",
      items: shopsItems
    });
  } else {
    let shopsItems$1 = shops.map(shop => ({
      TAG: "Option",
      key: shop.id,
      label: shop.name,
      value: shop.id
    }));
    let shopsSections = [{
      items: shopsItems$1
    }];
    tmp = JsxRuntime.jsx(CustomerForm.InputSelect.make, {
      field: "ShopId",
      label: I18n.t("Shop"),
      placeholder: I18n.t("Select a shop"),
      renderItem: param => {
        let item = param.item;
        if (item.TAG !== "Option") {
          return null;
        }
        let value = item.value;
        let shop = shops.find(shop => shop.id === value);
        return JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx("span", {
            children: item.label
          }), shop !== undefined ? JsxRuntime.jsx(Auth__Types.ShopKind.Badge.make, {
            value: shop.kind,
            size: "normal"
          }) : null],
          space: "normal",
          align: "spaceBetween"
        });
      },
      sections: shopsSections
    });
  }
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Selected shop"),
    description: I18n.t("Select the store for which you want to view or modify information."),
    accent: true,
    children: tmp
  });
}
let CustomerFormShopFieldset = {
  make: CustomerFormPage$CustomerFormShopFieldset
};
function CustomerFormPage$CustomerFormKindFieldset(props) {
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Customer type"),
    description: I18n.t("customer_new_page.kind_fieldset.description"),
    children: JsxRuntime.jsx(CustomerForm.InputToggleButtonGroup.make, {
      field: "Business",
      items: [{
        key: "individual",
        label: Customer.Kind.toLabel("Individual"),
        value: false
      }, {
        key: "business",
        label: Customer.Kind.toLabel("Business"),
        value: true
      }],
      grow: true,
      hideRequired: true
    })
  });
}
let CustomerFormKindFieldset = {
  make: CustomerFormPage$CustomerFormKindFieldset
};
function mergeCompanyAddress(addresses, company) {
  let otherAddresses = addresses.filter(address => address.key !== companyHeadOfficeAddressKey);
  let street = StringHelpers.stripEmptyString(company.street);
  if (street === undefined) {
    return otherAddresses;
  }
  let newrecord = {
    ...CustomerAddressEditModal.makeAddress(undefined, undefined)
  };
  newrecord.city = company.city;
  newrecord.postalCode = company.postalCode;
  newrecord.street = street;
  newrecord.recipient = company.corporateName;
  newrecord.label = I18n.t("Head office");
  newrecord.key = companyHeadOfficeAddressKey;
  return CustomerAddressEditModal.withExclusiveBilling(Belt_Array.concatMany([otherAddresses, [newrecord]]), newrecord);
}
function CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationCompanyField(props) {
  let onCompanyNameCleared = props.onCompanyNameCleared;
  let match = CustomerForm.useField("CompanyName", undefined, undefined, undefined, undefined);
  let onChange = match.onChange;
  let onInputChange = newValue => {
    onChange(newValue);
    if (newValue.trim() === "") {
      return onCompanyNameCleared();
    }
  };
  return JsxRuntime.jsx(CompanyComboBoxField.make, {
    errorMessage: match.error,
    required: match.required,
    companyName: match.value,
    onInputChange: onInputChange,
    onRequestAutoComplete: props.onCompanySelected
  });
}
let CustomerFormInformationCompanyField = {
  make: CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationCompanyField
};
let i18nPrefix$1 = "customer_form_page.loyalty_subscription.";
let styles = {
  illustrationContainer: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-x1peatla",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-x1fu8urw",
    $$css: "wino-gc:src/app/Customer/CustomerFormPage.res.js:2321"
  }
};
let illustrationStyle = {
  display: "block",
  height: "80%",
  width: "80%",
  objectFit: "contain"
};
function CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationLoyaltyField(props) {
  let welcomePoints = props.welcomePoints;
  let match = CustomerForm.useField("LoyaltySubscribed", undefined, undefined, undefined, undefined);
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(CanarySurface.make, {
          tone: "brand",
          shrink: false,
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx("img", {
              style: illustrationStyle,
              alt: "",
              src: Illustration.loyaltySrc
            }),
            style: Primitive_option.some(styles.illustrationContainer)
          })
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(InputToggleSwitchField.make, {
            label: I18n.t(i18nPrefix$1 + "toggle.label"),
            required: false,
            value: match.value,
            labelWeight: "semibold",
            onChange: match.onChange
          }), welcomePoints !== undefined && welcomePoints > 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: I18n.template(I18n.t(i18nPrefix$1 + "welcome_points"), {
                points: Loyalty.formatePoints(undefined, welcomePoints)
              }, undefined),
              variation: {
                NAME: "custom",
                VAL: "#A01E72"
              },
              weight: "semibold",
              size: "small"
            }), JsxRuntime.jsx(Box.make, {
              spaceBottom: "xxsmall"
            })]
          }) : null],
          space: "none"
        })],
        space: "xlarge",
        alignY: "center"
      }),
      spaceX: "large",
      spaceY: "large"
    })
  });
}
let CustomerFormInformationLoyaltyField = {
  i18nPrefix: i18nPrefix$1,
  styles: styles,
  illustrationStyle: illustrationStyle,
  make: CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationLoyaltyField
};
function CustomerFormPage$CustomerFormInformationFieldset(props) {
  let __withLoyaltySubscription = props.withLoyaltySubscription;
  let withLoyaltySubscription = __withLoyaltySubscription !== undefined ? __withLoyaltySubscription : false;
  let dispatch = CustomerForm.useFormDispatch();
  let match = CustomerForm.useFormState();
  let values = match.values;
  let match$1 = React.useContext(context);
  let setAutoCompletion = match$1[1];
  let autoCompletion = match$1[0];
  let onUseSuggestion = siret => {
    setAutoCompletion(values => ({
      companyName: values.companyName,
      firstName: values.firstName,
      lastName: values.lastName,
      addedAddressKey: values.addedAddressKey,
      companyNameConfirmed: true,
      suggestionUsed: true
    }));
    dispatch({
      TAG: "FieldValueChanged",
      _0: "Siret",
      _1: param => siret
    });
  };
  let restore = (field, previousValue, forget) => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: field,
      _1: param => previousValue
    });
    setAutoCompletion(forget);
  };
  let isFrenchBilling$1 = isFrenchBilling(values.billingCountry);
  let loyaltySubscribed = withLoyaltySubscription && !values.business && values.loyaltySubscribed;
  let suggestionAddress = Stdlib_Option.orElse(values.addresses.find(address => address.isBilling), values.addresses[0]);
  let onCompanyNameCleared = () => dispatch({
    TAG: "FieldsValuesChanged",
    _0: resetCompanyDerivedFields
  });
  let onCompanySelected = company => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CompanyName",
      _1: param => company.corporateName
    });
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.siret), siret => dispatch({
      TAG: "FieldValueChanged",
      _0: "Siret",
      _1: param => siret
    }));
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.vatNumber), vatNumber => dispatch({
      TAG: "FieldValueChanged",
      _0: "IntraCommunityVat",
      _1: param => vatNumber
    }));
    if (values.firstName.trim() === "" && values.lastName.trim() === "") {
      Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.directorFirstName), firstName => dispatch({
        TAG: "FieldValueChanged",
        _0: "FirstName",
        _1: param => firstName
      }));
      Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.directorLastName), lastName => dispatch({
        TAG: "FieldValueChanged",
        _0: "LastName",
        _1: param => lastName
      }));
    }
    dispatch({
      TAG: "FieldValueChanged",
      _0: "Addresses",
      _1: addresses => mergeCompanyAddress(addresses, company)
    });
  };
  let match$2 = values.business;
  let match$3 = props.withCompanyAutoComplete && isFrenchBilling$1;
  let companyPanel = JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("General information"),
    description: I18n.t("customer_new_page.information_fieldset.description"),
    accent: true,
    children: JsxRuntime.jsxs(Stack.make, {
      children: [match$2 ? match$3 ? JsxRuntime.jsx(CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationCompanyField, {
        onCompanySelected: onCompanySelected,
        onCompanyNameCleared: onCompanyNameCleared
      }) : JsxRuntime.jsx(CustomerForm.InputText.make, {
        field: "CompanyName",
        label: I18n.t("Company name"),
        placeholder: I18n.t("Company name")
      }) : null, overwrittenValueBanner(autoCompletion.companyName, values.companyName, previousValue => restore("CompanyName", previousValue, values => ({
        companyName: undefined,
        firstName: values.firstName,
        lastName: values.lastName,
        addedAddressKey: values.addedAddressKey,
        companyNameConfirmed: values.companyNameConfirmed,
        suggestionUsed: values.suggestionUsed
      }))), JsxRuntime.jsx(CustomerCompanySuggestion.make, {
        criteria: {
          companyName: values.companyName,
          directorFirstName: values.firstName,
          directorLastName: values.lastName,
          street: Stdlib_Option.mapOr(suggestionAddress, "", address => address.street),
          postalCode: Stdlib_Option.mapOr(suggestionAddress, "", address => address.postalCode),
          city: Stdlib_Option.mapOr(suggestionAddress, "", address => address.city)
        },
        variant: {
          TAG: "Form",
          onUse: onUseSuggestion
        },
        skip: !props.withCompanySuggestion || !values.business || !isFrenchBilling$1 || values.siret.trim() !== ""
      })],
      space: "small"
    })
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [values.business ? companyPanel : null, JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
      title: values.business ? "" : I18n.t("General information"),
      description: values.business ? "" : I18n.t("customer_new_page.information_fieldset.description"),
      children: [JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(CustomerForm.InputText.make, {
            field: "FirstName",
            label: I18n.t("First name"),
            placeholder: "Jean",
            hideRequired: values.business
          }), overwrittenValueBanner(autoCompletion.firstName, values.firstName, previousValue => restore("FirstName", previousValue, values => ({
            companyName: values.companyName,
            firstName: undefined,
            lastName: values.lastName,
            addedAddressKey: values.addedAddressKey,
            companyNameConfirmed: values.companyNameConfirmed,
            suggestionUsed: values.suggestionUsed
          })))],
          space: "small"
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(CustomerForm.InputText.make, {
            field: "LastName",
            label: I18n.t("Last name"),
            placeholder: "Dubois",
            hideRequired: values.business
          }), overwrittenValueBanner(autoCompletion.lastName, values.lastName, previousValue => restore("LastName", previousValue, values => ({
            companyName: values.companyName,
            firstName: values.firstName,
            lastName: undefined,
            addedAddressKey: values.addedAddressKey,
            companyNameConfirmed: values.companyNameConfirmed,
            suggestionUsed: values.suggestionUsed
          })))],
          space: "small"
        })],
        alignY: "flex-start"
      }), JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(CustomerForm.InputText.make, {
          field: "Email",
          label: I18n.t("Email address"),
          placeholder: I18n.t("monadresse@email.com"),
          hideRequired: !loyaltySubscribed
        }), values.business ? null : JsxRuntime.jsx(CustomerForm.InputOptionalDateFastNav.make, {
          label: I18n.t("Date of birth"),
          field: "DateOfBirth",
          disabledFutureDays: true,
          grow: true
        })],
        alignY: "flex-start"
      }), JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(CustomerForm.InputPhone.make, {
          label: I18n.t("Phone number"),
          field: "PhoneNumber",
          placeholder: "01 23 45 67 89"
        }), JsxRuntime.jsx(CustomerForm.InputPhone.make, {
          label: I18n.t("Mobile number"),
          field: "MobileNumber",
          placeholder: "06 12 34 56 78"
        })]
      }), withLoyaltySubscription && !values.business ? JsxRuntime.jsx(CustomerFormPage$CustomerFormInformationFieldset$CustomerFormInformationLoyaltyField, {
        welcomePoints: props.loyaltyWelcomePoints
      }) : null, loyaltySubscribed && values.email.trim() === "" ? JsxRuntime.jsx(NextBanner.make, {
        children: JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("customer_form_page.loyalty_subscription.email_banner.text")
        }),
        variation: "warning"
      }) : null]
    })]
  });
}
let CustomerFormInformationFieldset = {
  mergeCompanyAddress: mergeCompanyAddress,
  CustomerFormInformationCompanyField: CustomerFormInformationCompanyField,
  CustomerFormInformationLoyaltyField: CustomerFormInformationLoyaltyField,
  make: CustomerFormPage$CustomerFormInformationFieldset
};
function CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressTile(props) {
  let onRequestRemove = props.onRequestRemove;
  let onRequestEdit = props.onRequestEdit;
  let value = props.value;
  return JsxRuntime.jsx(CustomerLocationTile.make, {
    label: value.label,
    recipient: StringHelpers.stripEmptyString(value.recipient),
    street: StringHelpers.stripEmptyString(value.street),
    postalCode: StringHelpers.stripEmptyString(value.postalCode),
    city: StringHelpers.stripEmptyString(value.city),
    country: StringHelpers.stripEmptyString(value.country),
    isBilling: value.isBilling,
    isDelivery: value.isDelivery,
    endActionsElement: JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(Button.make, {
          tone: {
            NAME: "neutral",
            VAL: {
              quiet: true
            }
          },
          size: "small",
          icon: "edit",
          tooltipText: I18n.t("Edit"),
          onPress: () => onRequestEdit()
        }), JsxRuntime.jsx(Button.make, {
          variant: "subtle",
          tone: "danger",
          size: "small",
          icon: "delete",
          tooltipText: I18n.t("Remove"),
          onPress: () => onRequestRemove()
        })],
        space: "small",
        align: "end"
      }),
      align: "end",
      alignY: "center",
      grow: true,
      fullWidth: true
    }),
    onToggleBilling: props.onToggleBilling,
    onToggleDelivery: props.onToggleDelivery
  });
}
let CustomerFormAddressTile = {
  make: CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressTile
};
let styles$1 = {
  root: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x167g77z",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "minHeight-kAzted": "minHeight-xuxxueq",
    "padding-kmVPX3": "padding-x1qhigcl",
    $$css: "wino-gc:src/app/Customer/CustomerFormPage.res.js:2680"
  }
};
function CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressAddTile(props) {
  let onPress = props.onPress;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf gap-x167g77z justifyContent-xl56j7k minHeight-xuxxueq padding-x1qhigcl",
    "data-style-src": "wino-gc:src/app/Customer/CustomerFormPage.res.js:2680"
  };
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx(CanarySurface.make, {
      tone: "brand",
      grow: true,
      children: JsxRuntime.jsxs("div", {
        children: [JsxRuntime.jsx(Icon.make, {
          name: "plus_small",
          fill: hovered ? "#4D0A35" : "#A01E72",
          width: 16,
          height: 16,
          bold: true
        }), JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Add an address"),
          variation: {
            NAME: "custom",
            VAL: hovered ? "#4D0A35" : "#A01E72"
          },
          weight: "semibold",
          size: "small"
        })],
        className: match$1.className,
        style: match$1.style
      })
    }),
    wrap: false,
    grow: true,
    onPress: param => onPress(),
    ref: match[0]
  });
}
let CustomerFormAddressAddTile = {
  styles: styles$1,
  make: CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressAddTile
};
let i18nPrefix$2 = "customer_form_page.billing_country_mismatch.";
function CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressesCountryBanner(props) {
  return JsxRuntime.jsx(NextBanner.make, {
    children: JsxRuntime.jsx(NextBanner.Text.make, {
      text: I18n.template(I18n.t(i18nPrefix$2 + "text"), {
        addressCountry: toLabel(props.addressCountry),
        billingCountry: toLabel(props.billingCountry)
      }, undefined)
    }),
    variation: "warning",
    title: I18n.t(i18nPrefix$2 + "title")
  });
}
let CustomerFormAddressesCountryBanner = {
  i18nPrefix: i18nPrefix$2,
  make: CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressesCountryBanner
};
function CustomerFormPage$CustomerFormAddressesFieldset(props) {
  let match = CustomerForm.useField("Addresses", undefined, undefined, undefined, undefined);
  let onChange = match.onChange;
  let value = match.value;
  let match$1 = CustomerForm.useFormState();
  let values = match$1.values;
  let shopCountry = Stdlib_Option.mapOr(Auth.useShops().find(shop => shop.id === values.shopId), "", shop => shop.country);
  let match$2 = React.useContext(context);
  let mismatchedCountry = props.withBillingCountry && values.business ? mismatchedBillingAddressCountry(values.billingCountry, value) : undefined;
  let match$3 = React.useState(() => {});
  let setEdited = match$3[1];
  let edited = match$3[0];
  let match$4 = React.useState(() => {});
  let setPendingRemoval = match$4[1];
  let pendingRemoval = match$4[0];
  let editedIsNew = edited !== undefined ? !value.some(param => param.key === edited.key) : false;
  let onCommit = address => {
    let updated = value.some(param => param.key === address.key) ? value.map(current => {
      if (current.key === address.key) {
        return address;
      } else {
        return current;
      }
    }) : [address].concat(value);
    onChange(CustomerAddressEditModal.withExclusiveBilling(updated, address));
    return Future.value({
      TAG: "Ok",
      _0: undefined
    });
  };
  let onRequestRemoveConfirmed = () => Stdlib_Option.forEach(pendingRemoval, address => {
    onChange(value.filter(param => param.key !== address.key));
    setPendingRemoval(param => {});
  });
  let match$5 = values.billingCountry;
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Addresses"),
    description: I18n.t("customer_new_page.addresses_fieldset.description"),
    children: [mismatchedCountry !== undefined && match$5 !== undefined ? JsxRuntime.jsx(CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressesCountryBanner, {
      addressCountry: mismatchedCountry,
      billingCountry: match$5
    }) : null, Stdlib_Option.mapOr(match$2[0].addedAddressKey, null, addedAddressKey => {
      if (value.some(param => param.key === addedAddressKey)) {
        return JsxRuntime.jsx(CustomerFormPage$CustomerFormAutoCompletion$AddedAddressBanner, {});
      } else {
        return null;
      }
    }), JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressAddTile, {
        onPress: () => setEdited(param => CustomerAddressEditModal.makeAddress(shopCountry, value.length === 0))
      }), value.map(address => JsxRuntime.jsx(CustomerFormPage$CustomerFormAddressesFieldset$CustomerFormAddressTile, {
        value: address,
        onRequestEdit: () => setEdited(param => address),
        onRequestRemove: () => setPendingRemoval(param => address),
        onToggleBilling: isBilling => {
          let newrecord = {
            ...address
          };
          onCommit((newrecord.isBilling = isBilling, newrecord));
        },
        onToggleDelivery: isDelivery => {
          let newrecord = {
            ...address
          };
          onCommit((newrecord.isDelivery = isDelivery, newrecord));
        }
      }, address.key))],
      grid: value.length === 0 ? ["100%"] : ["50%", "50%"],
      wrap: true,
      grow: false,
      stretch: true,
      spaceX: "medium",
      spaceY: "medium",
      alignY: "stretch"
    }), JsxRuntime.jsx(CustomerAddressEditModal.make, {
      value: edited,
      isNew: editedIsNew,
      hasOtherBillingAddress: value.some(address => {
        if (address.isBilling) {
          return Stdlib_Option.mapOr(edited, true, param => param.key !== address.key);
        } else {
          return false;
        }
      }),
      recipientPlaceholder: props.recipientPlaceholder,
      onCommit: onCommit,
      onRequestClose: () => setEdited(param => {}),
      onRequestRemove: edited !== undefined && !editedIsNew ? () => {
        setEdited(param => {});
        setPendingRemoval(param => edited);
      } : undefined
    }), JsxRuntime.jsx(Modal.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("customer_addresses_field.remove_confirmation_modal.text"),
          variation: "normal"
        }),
        spaceX: "xlarge",
        spaceY: "xxlarge"
      }),
      opened: Stdlib_Option.isSome(pendingRemoval),
      title: I18n.t("customer_addresses_field.remove_confirmation_modal.title"),
      abortButtonText: I18n.t("Cancel"),
      commitButtonTone: "danger",
      commitButtonText: I18n.t("Remove"),
      commitButtonCallback: onRequestRemoveConfirmed,
      onRequestClose: () => setPendingRemoval(param => {})
    })]
  });
}
let CustomerFormAddressesFieldset = {
  CustomerFormAddressTile: CustomerFormAddressTile,
  CustomerFormAddressAddTile: CustomerFormAddressAddTile,
  CustomerFormAddressesCountryBanner: CustomerFormAddressesCountryBanner,
  make: CustomerFormPage$CustomerFormAddressesFieldset
};
function isOtherCustomer(currentCustomerId, nodeId) {
  return Stdlib_Option.mapOr(currentCustomerId, true, id => nodeId !== id);
}
function CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingSiretField(props) {
  let currentCustomerId = props.currentCustomerId;
  let dispatch = CustomerForm.useFormDispatch();
  let match = CustomerForm.useField("Siret", undefined, true, undefined, undefined);
  let onFocus = match.onFocus;
  let error = match.error;
  let value = match.value;
  let match$1 = React.useState(() => {});
  let setDuplicate = match$1[1];
  let duplicate = match$1[0];
  let debouncedSiret = ReactUpdateDebounced.use(value, 400);
  let ready = CompanyLegalNumber.French.isValidSiret(debouncedSiret);
  ReactUpdateEffect.use1(() => {
    setDuplicate(param => {});
    dispatch({
      TAG: "FieldValueChanged",
      _0: "SiretIsDuplicate",
      _1: param => false
    });
  }, [value]);
  let queryResult = use$6(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !ready, undefined, {
    search: debouncedSiret,
    filterBy: makeInputObjectInputCustomersQueryFilter({
      _in: [props.shopId]
    }, "EXCLUDED", undefined, undefined, undefined, undefined, undefined, undefined)
  });
  ReactUpdateEffect.use2(() => {
    let match = queryResult.data;
    if (ready && match !== undefined) {
      let duplicate = Stdlib_Option.map(match.customers.edges.filter(param => isOtherCustomer(currentCustomerId, param.node.id)).find(param => Stdlib_Option.mapOr(param.node.siret, false, siret => normalizeIdentifier(siret) === normalizeIdentifier(debouncedSiret))), param => {
        let node = param.node;
        return {
          id: node.id,
          name: Customer.makeName(node.firstName, node.lastName, node.companyName)
        };
      });
      setDuplicate(param => duplicate);
      dispatch({
        TAG: "FieldValueChanged",
        _0: "SiretIsDuplicate",
        _1: param => Stdlib_Option.isSome(duplicate)
      });
    }
  }, [debouncedSiret, queryResult.data]);
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(SiretInputField.make, {
      value: value,
      errored: Stdlib_Option.isSome(error),
      focused: match.focused,
      required: match.required,
      onChange: match.onChange,
      onCompanyFound: props.onCompanyFound,
      onFocus: () => onFocus(),
      onBlur: match.onBlur,
      errorMessage: error
    }), duplicate !== undefined ? JsxRuntime.jsxs(NextBanner.make, {
      children: [JsxRuntime.jsx(NextBanner.Text.make, {
        text: I18n.t("customer_form_page.siret_duplicate.text")
      }), JsxRuntime.jsx(NextBanner.Text.make, {
        text: "➔ " + Stdlib_Option.getOr(duplicate.name, I18n.t("customer_form_page.siret_duplicate.unnamed")),
        bold: true,
        href: props.customerShowRoute(duplicate.id),
        target: "_blank"
      })],
      variation: "danger",
      compact: true,
      grow: true
    }) : null],
    space: "small"
  });
}
let CustomerFormBillingSiretField = {
  make: CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingSiretField
};
function CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingIntraCommunityVatField(props) {
  let currentCustomerId = props.currentCustomerId;
  let checkDuplicates = props.checkDuplicates;
  let dispatch = CustomerForm.useFormDispatch();
  let match = CustomerForm.useFormState();
  let value = match.values.intraCommunityVat;
  let debouncedVat = ReactUpdateDebounced.use(value, 400);
  let ready = checkDuplicates && debouncedVat.trim() !== "";
  ReactUpdateEffect.use2(() => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "IntraCommunityVatIsDuplicate",
      _1: param => false
    });
  }, [value, checkDuplicates]);
  let queryResult = use$6(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !ready, undefined, {
    search: debouncedVat,
    filterBy: makeInputObjectInputCustomersQueryFilter({
      _in: [props.shopId]
    }, "INCLUDED", undefined, undefined, undefined, undefined, undefined, undefined)
  });
  ReactUpdateEffect.use2(() => {
    let match = queryResult.data;
    if (ready && match !== undefined) {
      let isDuplicate = match.customers.edges.filter(param => isOtherCustomer(currentCustomerId, param.node.id)).some(param => Stdlib_Option.mapOr(param.node.intraCommunityVAT, false, vat => normalizeIdentifier(vat) === normalizeIdentifier(debouncedVat)));
      dispatch({
        TAG: "FieldValueChanged",
        _0: "IntraCommunityVatIsDuplicate",
        _1: param => isDuplicate
      });
    }
  }, [debouncedVat, queryResult.data]);
  return JsxRuntime.jsx(CustomerForm.InputText.make, {
    field: "IntraCommunityVat",
    label: I18n.t("Intracommunity VAT number"),
    placeholder: "XX40123456789",
    hideRequired: true,
    copyable: true
  });
}
let CustomerFormBillingIntraCommunityVatField = {
  make: CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingIntraCommunityVatField
};
function CustomerFormPage$CustomerFormBillingFieldset$FrenchInvoicingEndpointFieldset(props) {
  let kind = props.kind;
  let siret = props.siret;
  let siren = CompanyLegalNumber.French.sirenFromSiret(siret);
  let tmp;
  let exit = 0;
  switch (kind) {
    case "Siren":
      tmp = null;
      break;
    case "SirenWithSuffix":
      tmp = JsxRuntime.jsx(CustomerForm.InputText.make, {
        field: "InvoicingEndpointSuffix",
        label: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.label"),
        placeholder: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.suffix_input.placeholder"),
        hideRequired: true,
        maxLength: ElectronicInvoicing.InvoicingEndpoint.French.complementMaxLength
      });
      break;
    case "Siret":
    case "SiretWithRoutingCode":
      exit = 1;
      break;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(InputTextField.make, {
      label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siret"),
      disabled: true,
      value: siret
    });
  }
  let tmp$1;
  tmp$1 = kind === "SiretWithRoutingCode" ? JsxRuntime.jsx(CustomerForm.InputText.make, {
    field: "InvoicingEndpointRoutingCode",
    label: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.label"),
    placeholder: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.routing_code_input.placeholder"),
    hideRequired: true,
    maxLength: ElectronicInvoicing.InvoicingEndpoint.French.complementMaxLength
  }) : null;
  return JsxRuntime.jsxs(Group.make, {
    children: [JsxRuntime.jsx(CustomerForm.InputSelect.make, {
      field: "InvoicingEndpointFrenchKind",
      label: ElectronicInvoicing.InvoicingEndpoint.selectLabel,
      sections: ElectronicInvoicing.InvoicingEndpoint.French.selectSections,
      hideRequired: true
    }), JsxRuntime.jsx(InputTextField.make, {
      label: ElectronicInvoicing.InvoicingEndpoint.French.identifierLabel("Siren"),
      disabled: true,
      value: siren
    }), tmp, tmp$1],
    alignY: "flex-start"
  });
}
let FrenchInvoicingEndpointFieldset = {
  make: CustomerFormPage$CustomerFormBillingFieldset$FrenchInvoicingEndpointFieldset
};
function CustomerFormPage$CustomerFormBillingFieldset$InvoicingEndpointDerivedBanner(props) {
  return JsxRuntime.jsx(NextBanner.make, {
    children: JsxRuntime.jsx(NextBanner.Text.make, {
      text: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.derived_warning")
    }),
    variation: "important"
  });
}
let InvoicingEndpointDerivedBanner = {
  make: CustomerFormPage$CustomerFormBillingFieldset$InvoicingEndpointDerivedBanner
};
function CustomerFormPage$CustomerFormBillingFieldset$BelgianInvoicingEndpointFieldset(props) {
  let kind = props.kind;
  return JsxRuntime.jsxs(Group.make, {
    children: [JsxRuntime.jsx(CustomerForm.InputSelect.make, {
      field: "InvoicingEndpointBelgianKind",
      label: ElectronicInvoicing.InvoicingEndpoint.selectLabel,
      sections: ElectronicInvoicing.InvoicingEndpoint.Belgian.selectSections,
      hideRequired: true
    }), JsxRuntime.jsx(InputTextField.make, {
      label: ElectronicInvoicing.InvoicingEndpoint.Belgian.identifierLabel(kind),
      disabled: true,
      value: ElectronicInvoicing.InvoicingEndpoint.Belgian.endpointId(kind, props.vatNumber)
    })],
    alignY: "flex-start"
  });
}
let BelgianInvoicingEndpointFieldset = {
  make: CustomerFormPage$CustomerFormBillingFieldset$BelgianInvoicingEndpointFieldset
};
function CustomerFormPage$CustomerFormBillingFieldset(props) {
  let withAddressAutoComplete = props.withAddressAutoComplete;
  let currentCustomerId = props.currentCustomerId;
  let dispatch = CustomerForm.useFormDispatch();
  let match = CustomerForm.useFormState();
  let values$1 = match.values;
  let match$1 = React.useContext(context);
  let setAutoCompletion = match$1[1];
  let withCompanyAutoComplete = props.withCompanyAutoComplete || match$1[0].suggestionUsed;
  let isFrenchBilling$1 = isFrenchBilling(values$1.billingCountry);
  ReactUpdateEffect.use1(() => {
    dispatch({
      TAG: "FieldsValuesChanged",
      _0: resetBillingFields
    });
  }, [Stdlib_Option.mapOr(values$1.billingCountry, "", key)]);
  let onCompanyFound = lookup => {
    if (lookup === undefined) {
      return;
    }
    let company = lookup.company;
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.corporateName), corporateName => dispatch({
      TAG: "FieldValueChanged",
      _0: "CompanyName",
      _1: param => corporateName
    }));
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.vatNumber), vatNumber => dispatch({
      TAG: "FieldValueChanged",
      _0: "IntraCommunityVat",
      _1: param => vatNumber
    }));
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.directorFirstName), firstName => dispatch({
      TAG: "FieldValueChanged",
      _0: "FirstName",
      _1: param => firstName
    }));
    Stdlib_Option.forEach(StringHelpers.stripEmptyString(company.directorLastName), lastName => dispatch({
      TAG: "FieldValueChanged",
      _0: "LastName",
      _1: param => lastName
    }));
    let addedAddress = withAddressAutoComplete ? headOfficeAddressToAdd(values$1.addresses, company) : undefined;
    Stdlib_Option.forEach(addedAddress, addedAddress => dispatch({
      TAG: "FieldValueChanged",
      _0: "Addresses",
      _1: addresses => addresses.concat([addedAddress])
    }));
    setAutoCompletion(param => ({
      companyName: param.companyNameConfirmed ? undefined : keepOverwritten(values$1.companyName, company.corporateName),
      firstName: keepOverwritten(values$1.firstName, company.directorFirstName),
      lastName: keepOverwritten(values$1.lastName, company.directorLastName),
      addedAddressKey: Stdlib_Option.map(addedAddress, param => param.key),
      companyNameConfirmed: false,
      suggestionUsed: param.suggestionUsed
    }));
  };
  let onCompanyFoundFillEmpty = lookup => {
    if (lookup === undefined) {
      return;
    }
    let company = lookup.company;
    let match = values$1.companyName.trim();
    let match$1 = StringHelpers.stripEmptyString(company.corporateName);
    if (match === "") {
      if (match$1 !== undefined) {
        dispatch({
          TAG: "FieldValueChanged",
          _0: "CompanyName",
          _1: param => match$1
        });
      }
    }
    let match$2 = values$1.intraCommunityVat.trim();
    let match$3 = StringHelpers.stripEmptyString(company.vatNumber);
    if (match$2 === "") {
      if (match$3 !== undefined) {
        dispatch({
          TAG: "FieldValueChanged",
          _0: "IntraCommunityVat",
          _1: param => match$3
        });
      }
    }
    let match$4 = values$1.firstName.trim();
    let match$5 = StringHelpers.stripEmptyString(company.directorFirstName);
    if (match$4 === "") {
      if (match$5 !== undefined) {
        dispatch({
          TAG: "FieldValueChanged",
          _0: "FirstName",
          _1: param => match$5
        });
      }
    }
    let match$6 = values$1.lastName.trim();
    let match$7 = StringHelpers.stripEmptyString(company.directorLastName);
    if (match$6 === "" && match$7 !== undefined) {
      return dispatch({
        TAG: "FieldValueChanged",
        _0: "LastName",
        _1: param => match$7
      });
    }
  };
  let countryItems = values.map(value => ({
    key: key(value),
    label: toLabel(value),
    value: value
  }));
  let match$2 = values$1.business;
  let match$3 = values$1.billingCountry;
  let tmp;
  if (match$2 && match$3 !== undefined) {
    switch (match$3) {
      case "France":
        tmp = CompanyLegalNumber.French.isValidSiret(values$1.siret) ? JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$FrenchInvoicingEndpointFieldset, {
            siret: values$1.siret,
            kind: values$1.invoicingEndpointFrenchKind
          }), JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$InvoicingEndpointDerivedBanner, {})],
          space: "normal"
        }) : null;
        break;
      case "Belgium":
        tmp = CompanyLegalNumber.Vat.isValid(values$1.intraCommunityVat) ? JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$BelgianInvoicingEndpointFieldset, {
            vatNumber: values$1.intraCommunityVat,
            kind: values$1.invoicingEndpointBelgianKind
          }), JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$InvoicingEndpointDerivedBanner, {})],
          space: "normal"
        }) : null;
        break;
      case "Other":
        tmp = null;
        break;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Billing"),
    description: I18n.t("customer_new_page.billing_fieldset.description"),
    children: [JsxRuntime.jsx(CustomerForm.InputToggleButtonGroup.make, {
      field: "BillingCountry",
      label: I18n.t("Country"),
      items: countryItems,
      grow: true
    }), values$1.business ? JsxRuntime.jsxs(Group.make, {
      children: [isFrenchBilling$1 ? JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingSiretField, {
        onCompanyFound: withCompanyAutoComplete ? onCompanyFound : onCompanyFoundFillEmpty,
        shopId: values$1.shopId,
        currentCustomerId: currentCustomerId,
        customerShowRoute: props.customerShowRoute
      }) : null, JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset$CustomerFormBillingIntraCommunityVatField, {
        shopId: values$1.shopId,
        checkDuplicates: !isFrenchBilling$1,
        currentCustomerId: currentCustomerId
      })]
    }) : null, tmp]
  });
}
let CustomerFormBillingFieldset = {
  isOtherCustomer: isOtherCustomer,
  CustomerFormBillingSiretField: CustomerFormBillingSiretField,
  CustomerFormBillingIntraCommunityVatField: CustomerFormBillingIntraCommunityVatField,
  FrenchInvoicingEndpointFieldset: FrenchInvoicingEndpointFieldset,
  InvoicingEndpointDerivedBanner: InvoicingEndpointDerivedBanner,
  BelgianInvoicingEndpointFieldset: BelgianInvoicingEndpointFieldset,
  make: CustomerFormPage$CustomerFormBillingFieldset
};
function CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceEmptyPlaceholder(props) {
  let shopId = props.shopId;
  let shopName = Stdlib_Option.mapOr(Auth.useShops().find(shop => shop.id === shopId), "", shop => shop.name);
  return JsxRuntime.jsx(CanarySurface.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Title.make, {
        children: I18n.template(I18n.t("customer_form_page.price_fieldset.empty_placeholder"), {
          shop: shopName
        }, undefined),
        level: 4,
        align: "center",
        weight: "medium",
        color: "#25243A"
      }),
      spaceX: "large",
      spaceY: "xlarge"
    })
  });
}
let CustomerFormPriceEmptyPlaceholder = {
  make: CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceEmptyPlaceholder
};
function queryVariables(shopId) {
  return {
    filterBy: {
      shopIds: {
        _in: [shopId]
      },
      archived: "EXCLUDED"
    }
  };
}
function taxBadgeElement(taxIncluded) {
  return JsxRuntime.jsx(Badge.make, {
    children: I18n.t(taxIncluded ? "VAT incl." : "VAT excl."),
    size: "small",
    variation: "neutral"
  });
}
function CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceField(props) {
  let shopId = props.shopId;
  let dispatch = CustomerForm.useFormDispatch();
  let queryResult = use$5(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, queryVariables(shopId));
  let queryAsyncResult = ApolloHelpers.queryResultToAsyncResult(queryResult);
  ReactUpdateEffect.use1(() => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "PriceId",
      _1: param => ""
    });
  }, [shopId]);
  let prices = React.useMemo(() => {
    let edges;
    if (typeof queryAsyncResult !== "object") {
      if (queryAsyncResult === "NotAsked") {
        return [];
      } else {
        return [];
      }
    }
    if (queryAsyncResult.TAG === "Reloading") {
      let match = queryAsyncResult._0;
      if (match.TAG !== "Ok") {
        return [];
      }
      edges = match._0.prices.edges;
    } else {
      let match$1 = queryAsyncResult._0;
      if (match$1.TAG !== "Ok") {
        return [];
      }
      edges = match$1._0.prices.edges;
    }
    return edges.map(param => param.node);
  }, [queryResult.data, queryResult.previousData]);
  let pricesLoaded;
  pricesLoaded = typeof queryAsyncResult !== "object" ? false : queryAsyncResult.TAG === "Reloading" ? queryAsyncResult._0.TAG === "Ok" : queryAsyncResult._0.TAG === "Ok";
  if (pricesLoaded && prices.length === 0) {
    return JsxRuntime.jsx(CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceEmptyPlaceholder, {
      shopId: shopId
    });
  }
  if (prices.length <= 4) {
    let priceItems = prices.map(param => {
      let id = param.id;
      return {
        key: id,
        label: param.name,
        value: id,
        endElement: taxBadgeElement(param.taxIncluded)
      };
    });
    return JsxRuntime.jsx(CustomerForm.InputToggleButtonGroup.make, {
      field: "PriceId",
      items: priceItems,
      emptyValue: "",
      grow: true
    });
  }
  let priceItems$1 = prices.map(param => {
    let id = param.id;
    return {
      TAG: "Option",
      key: id,
      label: param.name,
      value: id,
      endElement: taxBadgeElement(param.taxIncluded)
    };
  });
  let priceSections = [{
    items: [{
      TAG: "Option",
      key: "none",
      label: I18n.t("No price list"),
      value: ""
    }]
  }, {
    items: priceItems$1
  }];
  return JsxRuntime.jsx(CustomerForm.InputSelect.make, {
    field: "PriceId",
    label: I18n.t("Price list"),
    placeholder: I18n.t("Select a price list"),
    sections: priceSections
  });
}
let CustomerFormPriceField = {
  queryVariables: queryVariables,
  taxBadgeElement: taxBadgeElement,
  make: CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceField
};
function CustomerFormPage$CustomerFormPriceFieldset(props) {
  let match = CustomerForm.useFormState();
  let values = match.values;
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Price list"),
    description: I18n.t("customer_new_page.price_fieldset.description"),
    children: values.shopId !== "" ? JsxRuntime.jsx(CustomerFormPage$CustomerFormPriceFieldset$CustomerFormPriceField, {
      shopId: values.shopId
    }) : null
  });
}
let CustomerFormPriceFieldset = {
  CustomerFormPriceEmptyPlaceholder: CustomerFormPriceEmptyPlaceholder,
  CustomerFormPriceField: CustomerFormPriceField,
  make: CustomerFormPage$CustomerFormPriceFieldset
};
function CustomerFormPage$CustomerFormMiscFieldset(props) {
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Notes"),
    description: I18n.t("customer_new_page.misc_fieldset.description"),
    children: [JsxRuntime.jsx(CustomerForm.InputText.make, {
      field: "InternalCode",
      label: I18n.t("Internal code"),
      placeholder: I18n.t("Internal code"),
      copyable: true
    }), JsxRuntime.jsx(CustomerForm.InputTextArea.make, {
      field: "Note",
      label: I18n.t("Internal note")
    })]
  });
}
let CustomerFormMiscFieldset = {
  make: CustomerFormPage$CustomerFormMiscFieldset
};
function CustomerFormPage$CustomerFormView$CustomerFormCancelButton(props) {
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  if (match[0]) {
    return JsxRuntime.jsx(Button.make, {
      label: I18n.t("Cancel"),
      onPress: () => onGoBack()
    });
  } else {
    return JsxRuntime.jsx(CustomerForm.CancelButton.make, {
      label: I18n.t("Cancel")
    });
  }
}
let CustomerFormCancelButton = {
  make: CustomerFormPage$CustomerFormView$CustomerFormCancelButton
};
function CustomerFormPage$CustomerFormView(props) {
  let __withSiretAutoComplete = props.withSiretAutoComplete;
  let customerNewRoute = props.customerNewRoute;
  let customerShowRoute = props.customerShowRoute;
  let mode = props.mode;
  let withSiretAutoComplete = __withSiretAutoComplete !== undefined ? __withSiretAutoComplete : false;
  let navigate = Navigation.useNavigate();
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let match$1 = Navigation.useUrl();
  let state = match$1.state;
  let scope = Auth.useScope();
  let match$2 = React.useState(() => {});
  let setNotificationError = match$2[1];
  let notificationError = match$2[0];
  let onSubmitFailure = error => setNotificationError(param => error);
  let onSubmitSuccess = success => {
    if (success === undefined) {
      return setNotificationError(param => Request.serverErrorMessage);
    }
    if (typeof mode === "object" && canGoBack && Stdlib_Option.isSome(state)) {
      return onGoBack();
    }
    navigate({
      replace: true,
      state: state
    }, customerShowRoute(success));
  };
  let shops = Auth.useShops();
  let fieldsets = fromFormMode(mode);
  let isCreate;
  isCreate = typeof mode !== "object";
  let match$3 = CustomerForm.useFormPropState({
    id: props.formId,
    initialValues: props.initialValues,
    schema: customerFormSchema(fieldsets.information, undefined),
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let formDispatch = match$3[1];
  let formState = match$3[0];
  ReactUpdateEffect.use1(() => {
    Stdlib_Option.forEach(Stdlib_Option.flatMap(shops.find(shop => shop.id === formState.values.shopId), shop => fromCountryCode(CountryCode.parseIso3166Alpha2(shop.country))), billingCountry => formDispatch({
      TAG: "FieldValueChanged",
      _0: "BillingCountry",
      _1: param => billingCountry
    }));
  }, [formState.values.shopId]);
  ReactUpdateEffect.use1(() => {
    if (isCreate) {
      navigate({
        replace: true
      }, customerNewRoute(formState.values.business));
    }
  }, [formState.values.business]);
  let autoCompletion = React.useState(() => initialValues);
  let match$4 = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let createCustomerMutation = match$4[0];
  let match$5 = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let updateCustomerMutation = match$5[0];
  let match$6 = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let loyaltySubscribeMutation = match$6[0];
  let loyaltyAddonActivated = Loyalty.useAddonActivated(formState.values.shopId);
  let withLoyaltySubscription = isCreate && !formState.values.business && loyaltyAddonActivated;
  let shopLoyaltyQueryResult = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !withLoyaltySubscription || formState.values.shopId === "", undefined, {
    id: formState.values.shopId
  });
  let loyaltyWelcomePoints = Stdlib_Option.flatMap(shopLoyaltyQueryResult.data, param => Stdlib_Option.flatMap(param.shop, param => param.loyaltyWelcomePoints));
  ReactUpdateEffect.use1(() => {
    if (!withLoyaltySubscription) {
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "LoyaltySubscribed",
        _1: param => false
      });
    }
  }, [withLoyaltySubscription]);
  let createdCustomerId = React.useRef(undefined);
  let subscribeToLoyalty = (id, values) => {
    if (!values.business && values.loyaltySubscribed && Loyalty.isAddonActivated(shops, values.shopId)) {
      return Future.mapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(loyaltySubscribeMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id,
        isLoyaltyConsentGiven: true
      })), undefined, param => id), undefined, error => I18n.template(I18n.t("customer_form_page.loyalty_subscription.failure"), {
        error: error
      }, undefined));
    } else {
      return Future.value({
        TAG: "Ok",
        _0: id
      });
    }
  };
  let onSubmit = (param, values) => {
    let match = createdCustomerId.current;
    if (typeof mode !== "object") {
      if (match !== undefined) {
        return Future.flatMapOk(ApolloHelpers.mutationPromiseToFutureResult(updateCustomerMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, updateMutationVariablesFromIdAndFormValues(match, values))), undefined, param => subscribeToLoyalty(match, values));
      } else {
        return Future.flatMapOk(ApolloHelpers.mutationPromiseToFutureResult(createCustomerMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, createMutationVariablesFromFormValues(values))), undefined, param => {
          let match = param.createCustomer;
          let locations = match.locations;
          let id = match.id;
          createdCustomerId.current = id;
          formDispatch({
            TAG: "FieldValueChanged",
            _0: "Addresses",
            _1: param => addressesFromLocations(locations)
          });
          return subscribeToLoyalty(id, values);
        });
      }
    } else {
      return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(updateCustomerMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, updateMutationVariablesFromIdAndFormValues(mode.id, values))), undefined, param => param.updateCustomer.id);
    }
  };
  let value = StringHelpers.stripEmptyString(formState.values.companyName);
  let customerName = Customer.makeName(StringHelpers.stripEmptyString(formState.values.firstName), StringHelpers.stripEmptyString(formState.values.lastName), formState.values.business ? value : undefined);
  let mainActionsElement = JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormView$CustomerFormCancelButton, {}), JsxRuntime.jsx(CustomerForm.SubmitButton.make, {
      label: isCreate ? I18n.t("Create customer") : I18n.t("Save"),
      tone: "success",
      onSubmit: onSubmit
    })],
    space: "small"
  });
  let notificationBanner = notificationError !== undefined ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(NextBanner.make, {
      children: JsxRuntime.jsx(NextBanner.Text.make, {
        text: notificationError
      }),
      variation: "danger"
    }),
    spaceBottom: "large"
  }) : null;
  let tmp;
  let exit = 0;
  if (isCreate && scope.TAG === "Organisation") {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormShopFieldset, {}), JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal"
      })]
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = isCreate ? JsxRuntime.jsx(CanarySeparator.make, {
      orientation: "horizontal"
    }) : null;
  }
  return JsxRuntime.jsx(make, {
    value: autoCompletion,
    children: JsxRuntime.jsx(CustomerForm.Core.Provider.make, {
      children: JsxRuntime.jsx(NextPage.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [notificationBanner, isCreate ? JsxRuntime.jsx(CustomerFormPage$CustomerFormKindFieldset, {}) : null, tmp, fieldsets.information ? JsxRuntime.jsx(CustomerFormPage$CustomerFormInformationFieldset, {
            withCompanyAutoComplete: isCreate,
            withCompanySuggestion: !isCreate && !withSiretAutoComplete,
            withLoyaltySubscription: withLoyaltySubscription,
            loyaltyWelcomePoints: loyaltyWelcomePoints
          }) : null, fieldsets.information && formState.values.business ? JsxRuntime.jsx(CustomerFormPage$CustomerFormBillingFieldset, {
            currentCustomerId: customerId(mode),
            customerShowRoute: customerShowRoute,
            withCompanyAutoComplete: isCreate || withSiretAutoComplete,
            withAddressAutoComplete: fieldsets.addresses
          }) : null, fieldsets.addresses ? JsxRuntime.jsx(CustomerFormPage$CustomerFormAddressesFieldset, {
            recipientPlaceholder: customerName,
            withBillingCountry: fieldsets.information
          }) : null, fieldsets.misc ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [JsxRuntime.jsx(CustomerFormPage$CustomerFormPriceFieldset, {}), JsxRuntime.jsx(CustomerFormPage$CustomerFormMiscFieldset, {})]
          }) : null],
          space: "large"
        }),
        title: Stdlib_Option.getOr(customerName, isCreate ? I18n.t("New customer") : I18n.t("Edit customer")),
        subtitle: Customer.Kind.toLabel(formState.values.business ? "Business" : "Individual"),
        subtitleBadgeElement: isCreate ? JsxRuntime.jsx(NextBadge.make, {
          kind: "Neutral",
          label: I18n.t("Draft"),
          size: "L",
          icon: "Pending"
        }) : undefined,
        mainActionsElement: mainActionsElement,
        onRequestGoBack: canGoBack ? onGoBack : undefined
      }),
      propState: [formState, formDispatch]
    })
  });
}
let CustomerFormView = {
  CustomerFormCancelButton: CustomerFormCancelButton,
  make: CustomerFormPage$CustomerFormView
};
function CustomerFormPage$CustomerFormCreatePage(props) {
  let scope = Auth.useScope();
  let shop;
  if (scope.TAG === "Organisation") {
    let shop$1 = scope.activeShop;
    shop = shop$1 !== undefined ? Primitive_option.some(shop$1) : scope.shops.length !== 0 ? Primitive_option.some(undefined) : undefined;
  } else {
    shop = Primitive_option.some(scope._0);
  }
  if (shop === undefined) {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
  let shop$2 = Primitive_option.valFromOption(shop);
  let shopId = Stdlib_Option.mapOr(shop$2, "", shop => shop.id);
  let shopCountry = Stdlib_Option.mapOr(shop$2, "", shop => shop.country);
  return JsxRuntime.jsx(CustomerFormPage$CustomerFormView, {
    mode: "Create",
    initialValues: customerFormInitialValues(shopId, shopCountry, props.business),
    formId: "customer-new",
    customerShowRoute: props.customerShowRoute,
    customerNewRoute: props.customerNewRoute
  });
}
let CustomerFormCreatePage = {
  make: CustomerFormPage$CustomerFormCreatePage
};
function CustomerFormPage$CustomerFormEditPage(props) {
  let id = props.id;
  let shops = Auth.useShops();
  let asyncQueryResult = ApolloHelpers.queryResultToAsyncResult(use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  }));
  if (typeof asyncQueryResult !== "object") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  if (asyncQueryResult.TAG !== "Done") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  let match = asyncQueryResult._0;
  if (match.TAG !== "Ok") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
  let customer = match._0.customer;
  let shopCountry = Stdlib_Option.mapOr(shops.find(shop => shop.id === customer.shop.id), "", shop => shop.country);
  let initialValues = customerFormInitialValuesFromQueryResult(shopCountry, customer);
  let suggestedSiret = Stdlib_Option.filter(props.suggestedSiret, siret => {
    if (initialValues.business) {
      return CompanyLegalNumber.French.isValidSiret(siret);
    } else {
      return false;
    }
  });
  let tmp;
  if (suggestedSiret !== undefined) {
    let newrecord = {
      ...initialValues
    };
    newrecord.siret = suggestedSiret;
    newrecord.billingCountry = "France";
    tmp = newrecord;
  } else {
    tmp = initialValues;
  }
  return JsxRuntime.jsx(CustomerFormPage$CustomerFormView, {
    mode: {
      TAG: "Edit",
      id: id,
      section: props.section
    },
    initialValues: tmp,
    formId: id,
    customerShowRoute: props.customerShowRoute,
    customerNewRoute: props.customerNewRoute,
    withSiretAutoComplete: Stdlib_Option.isSome(suggestedSiret)
  });
}
let CustomerFormEditPage = {
  make: CustomerFormPage$CustomerFormEditPage
};
function CustomerFormPage(props) {
  let __business = props.business;
  let customerNewRoute = props.customerNewRoute;
  let customerShowRoute = props.customerShowRoute;
  let mode = props.mode;
  let business = __business !== undefined ? __business : false;
  if (typeof mode !== "object") {
    return JsxRuntime.jsx(CustomerFormPage$CustomerFormCreatePage, {
      business: business,
      customerShowRoute: customerShowRoute,
      customerNewRoute: customerNewRoute
    });
  } else {
    return JsxRuntime.jsx(CustomerFormPage$CustomerFormEditPage, {
      id: mode.id,
      section: mode.section,
      customerShowRoute: customerShowRoute,
      customerNewRoute: customerNewRoute,
      suggestedSiret: props.suggestedSiret
    });
  }
}
let InvoicingEndpointFrenchKind;
let InvoicingEndpointBelgianKind;
let stripEmptyString = StringHelpers.stripEmptyString;
let make$1 = CustomerFormPage;
export { CustomerFormMode, CustomerFormFieldsets, InvoicingEndpointFrenchKind, InvoicingEndpointBelgianKind, CustomerFormBillingCountry, CustomerFormFragment, CustomerFormCreateMutation, CustomerFormUpdateMutation, CustomerFormLoyaltySubscribeMutation, CustomerFormShopLoyaltyQuery, CustomerFormQuery, CustomerFormPricesQuery, CustomerFormDuplicateCheckQuery, CustomerFormLenses, CustomerForm, notEmptyResult, stripEmptyString, orEmptyString, keepWhen, orNull, normalizeIdentifier, companyHeadOfficeAddressKey, compactAddressPart, headOfficeAddressToAdd, CustomerFormAutoCompletion, overwrittenValueBanner, billingAddressCountryCode, billingCountryFromIdentifiers, defaultBillingCountry, mismatchedBillingAddressCountry, isFrenchBilling, resetCompanyDerivedFields, resetBillingFields, invoicingEndpointFromValues, addressesFromLocations, customerFormSchema, customerFormInitialValues, customerFormInitialValuesFromQueryResult, createMutationVariablesFromFormValues, locationsInputFromAddresses, updateMutationVariablesFromIdAndFormValues, CustomerFormShopFieldset, CustomerFormKindFieldset, CustomerFormInformationFieldset, CustomerFormAddressesFieldset, CustomerFormBillingFieldset, CustomerFormPriceFieldset, CustomerFormMiscFieldset, CustomerFormView, CustomerFormCreatePage, CustomerFormEditPage, make$1 as make };
/* query Not a pure module */